<template>
  <div id="home">
    <!--  背景渐变色  -->
    <div class="background">
    <div class="bg-color" :style="{background:carouselList[carouselIndex].back_color}">
      <div class="mask"></div>
    </div>
      <!--  头部导航  -->
      <div class="header">
        <div class="header_first">
          <div class="header_first_left">
            <div class="header_first_left_top">
              <div class="hot_service_img">
                <img src="@/assets/image/Home/topGamesIco.png" alt="">
              </div>
              <div class="hot_service_text">热门服务</div>
            </div>
            <div class="header_first_left_bot">
              <div @click="PCHotServiceClick('游戏账号','')">
                <router-link :to="{name:'AllGame'}" class="game_type_list">
                  <div class="type_name">
                    <i class="service_icon el-icon-user"></i>
                    <span>游戏账号</span>
                    <i class="el-icon-arrow-right"></i>
                  </div>
                  <div class="type_game">
                    天涯明月刀&emsp;剑灵
                  </div>
                  <!--  热门服务 遮罩层  -->
                  <div class="game_type_bullet game" @click.prevent="">
                    <!--  热门服务 顶部  -->
                    <div class="game_type_bullet_title">
                      <div class="game_type_bullet_title_top">
                        <div class="bullet_title">
                          <div :class="game_click == ''?'game_click':''" @click.prevent="changeGame_click('')">
                            全部游戏
                          </div>
                          <div v-for="(item,index) in gameClass" :key="index"
                               :class="game_click == item.id?'game_click':''" @click.prevent="changeGame_click(item.id)">
                            {{ item.class_name }}
                          </div>

                          <!--                        <div id="peGame" :class="game_click == 2?'game_click':''" @click="changeGame_click(2)">-->
                          <!--                          手机游戏-->
                          <!--                        </div>-->
                        </div>
                        <router-link :to="{name:'AllGame'}" class="game_type_bullet_area">全部<i
                          class="el-icon-arrow-right"></i></router-link>
                      </div>
                      <div class="game_type_bullet_title_bot">
                        <div class="list_item opiton">
                          <div>
                          <span :class="game_letter===item?'active_A-Z':''" v-for="item in alphabet" :key="item"
                                v-text="item" @click.prevent="getgame_list(item)"></span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!--  热门服务 内容  -->
                    <div class="game_type_bullet_list">
                      <a class="game_type_bullet_list_item" v-for="(item,index) in game_list" :key="index"
                         :id="index % 6 !== 0 ?'line_not_first_item':''" :title="item.game_name" @click.stop.prevent="pc_game_item(item,1);PCHotServiceClick('游戏账号',item.game_name)">
                        <div class="game_type_bullet_list_item_img">
                          <img v-lazy="item.game_image" />
                        </div>
                        <div class="game_type_bullet_list_item_text" :title="item.game_name">{{ item.game_name }}</div>
                      </a>
                    </div>
                  </div>
                </router-link>
              </div>
              <div @click="PCHotServiceClick('账号估价','')">
                <router-link :to="{name:'AccountValuation'}" class="game_type_list accountValuation">
                  <!--             <router-link :to="{name:''}" class="game_type_list accountValuation">-->
                  <div class="type_name">
                    <i class="service_icon el-icon-data-analysis"></i>
                    <span>账号估价</span>
                    <i class="el-icon-arrow-right"></i>
                  </div>
                  <div class="type_game">
                    天涯明月刀&emsp;英雄联盟
                  </div>
                  <!--               <div class="inDev">-->
                  <!--                  <div>该功能正在开发中，敬请期待！</div>-->
                  <!--                </div>-->
                </router-link>
              </div>
              <div @click="PCHotServiceClick('装备道具','')">
              <router-link :to="{name:'AllGame'}" class="game_type_list first_recharge">
                <div class="type_name">
                  <i class="service_icon el-icon-box"></i>
                  <span>装备道具</span>
                  <i class="el-icon-arrow-right"></i>
                </div>
                <div class="type_game">
                  QQ三国
                </div>
                <!--  热门服务 遮罩层  -->
                <div class="game_type_bullet first_recharge" @click.prevent="">
                  <!--  热门服务 顶部  -->
                  <div class="game_type_bullet_title">
                    <div class="game_type_bullet_title_top">
                      <div class="bullet_title">
                        <div :class="game_click == ''?'game_click':''" @click.prevent="changeGame_click('')">
                          全部游戏
                        </div>
                        <div v-for="(item,index) in gameClass" :key="index"
                             :class="game_click == item.id?'game_click':''" @click.prevent="changeGame_click(item.id)">
                          {{ item.class_name }}
                        </div>
                      </div>
                      <router-link :to="{name:'AllGame'}" class="game_type_bullet_area">全部<i
                        class="el-icon-arrow-right"></i></router-link>
                    </div>
                    <div class="game_type_bullet_title_bot">
                      <div class="list_item opiton">
                        <div>
                          <span :class="game_letter===item?'active_A-Z':''" v-for="item in alphabet" :key="item"
                                v-text="item" @click.prevent="getgame_list(item)"></span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!--  热门服务 内容  -->
                  <div class="game_type_bullet_list">
                    <a class="game_type_bullet_list_item" v-for="(item,index) in game_listEquip" :key="index"
                         :id="index % 6 !== 0 ?'line_not_first_item':''" :title="item.game_name" @click.stop.prevent="pc_game_item(item,2);PCHotServiceClick('装备道具',item.game_name)">
                      <div class="game_type_bullet_list_item_img">
                        <img v-lazy="item.game_image" />
                      </div>
                      <div class="game_type_bullet_list_item_text" :title="item.game_name">{{ item.game_name }}</div>
                    </a>
                  </div>
                </div>
              </router-link>
              </div>
<!--              <div class="game_type_list gold">
                <div class="type_name">
                  <img src="@/assets/image/Home/gameType2.png" alt="">
                  <span>游戏金币</span>
                  <i class="el-icon-arrow-right"></i>
                </div>
                <div class="type_game">
                  QQ三国
                </div>
                <div class="inDev">
                  <div>该功能正在开发中，敬请期待！</div>
                </div>
                &lt;!&ndash;  热门服务 遮罩层  &ndash;&gt;
                &lt;!&ndash;                <div class="game_type_bullet gold">&ndash;&gt;
                &lt;!&ndash;                  &lt;!&ndash;  热门服务 顶部  &ndash;&gt;&ndash;&gt;
                &lt;!&ndash;                  <div class="game_type_bullet_title">&ndash;&gt;
                &lt;!&ndash;                    <div class="game_type_bullet_title_top">&ndash;&gt;
                &lt;!&ndash;                      <div class="bullet_title">&ndash;&gt;
                &lt;!&ndash;                        <div :class="game_click == ''?'game_click':''" @click="changeGame_click('')">&ndash;&gt;
                &lt;!&ndash;                          全部游戏&ndash;&gt;
                &lt;!&ndash;                        </div>&ndash;&gt;
                &lt;!&ndash;                        <div v-for="(item,index) in gameClass" :key="index"&ndash;&gt;
                &lt;!&ndash;                             :class="game_click == item.id?'game_click':''" @click="changeGame_click(item.id)">&ndash;&gt;
                &lt;!&ndash;                          {{ item.class_name }}&ndash;&gt;
                &lt;!&ndash;                        </div>&ndash;&gt;
                &lt;!&ndash;                      </div>&ndash;&gt;
                &lt;!&ndash;                      <router-link :to="{name:'AllGame'}" class="game_type_bullet_area">全部<i&ndash;&gt;
                &lt;!&ndash;                        class="el-icon-arrow-right"></i></router-link>&ndash;&gt;
                &lt;!&ndash;                    </div>&ndash;&gt;
                &lt;!&ndash;                    <div class="game_type_bullet_title_bot">&ndash;&gt;
                &lt;!&ndash;                      <div class="list_item opiton">&ndash;&gt;
                &lt;!&ndash;                        <div>&ndash;&gt;
                &lt;!&ndash;                          <span :class="game_letter===item?'active_A-Z':''" v-for="item in alphabet" :key="item"&ndash;&gt;
                &lt;!&ndash;                                v-text="item" @click="getgame_list(item)"></span>&ndash;&gt;
                &lt;!&ndash;                        </div>&ndash;&gt;
                &lt;!&ndash;                      </div>&ndash;&gt;
                &lt;!&ndash;                    </div>&ndash;&gt;
                &lt;!&ndash;                  </div>&ndash;&gt;
                &lt;!&ndash;                  &lt;!&ndash;  热门服务 内容  &ndash;&gt;&ndash;&gt;
                &lt;!&ndash;                  <div class="game_type_bullet_list">&ndash;&gt;
                &lt;!&ndash;                    <div class="game_type_bullet_list_item" v-for="(item,index) in game_listGold" :key="index"&ndash;&gt;
                &lt;!&ndash;                         :id="index % 6 !== 0 ?'line_not_first_item':''" @click="pc_game_item(item,3)">&ndash;&gt;
                &lt;!&ndash;                      <div class="game_type_bullet_list_item_img">&ndash;&gt;
                &lt;!&ndash;                        <img :src="item.game_image" alt="">&ndash;&gt;
                &lt;!&ndash;                      </div>&ndash;&gt;
                &lt;!&ndash;                      <div class="game_type_bullet_list_item_text">{{ item.game_name }}</div>&ndash;&gt;
                &lt;!&ndash;                    </div>&ndash;&gt;
                &lt;!&ndash;                  </div>&ndash;&gt;
                &lt;!&ndash;                </div>&ndash;&gt;
              </div>-->
              <div @click="PCHotServiceClick('账号回收','')">
                <router-link :to="{name:'AccountRecycle'}" class="game_type_list">
                  <div class="type_name">
                    <i class="service_icon el-icon-refresh"></i>
                    <span>账号回收</span>
                    <i class="el-icon-arrow-right"></i>
                  </div>
                  <div class="type_game">
                    天涯明月刀&emsp;剑灵
                  </div>
                  <!--                <div class="game_type_bullet account_recycle">-->
                  <!--                  &lt;!&ndash;  热门服务 顶部  &ndash;&gt;-->
                  <!--                  <div class="game_type_bullet_title">-->
                  <!--                    <div class="game_type_bullet_title_top">-->
                  <!--                      <div class="bullet_title">账号回收</div>-->
                  <!--                      <router-link tag="div" class="game_type_bullet_area" :to="{name:'accountRecycle'}">进入账号回收专区 <i class="el-icon-arrow-right"></i></router-link>-->
                  <!--                    </div>-->
                  <!--                    <div class="game_type_bullet_title_bot">-->
                  <!--                      <div class="list_item opiton">-->
                  <!--                        <div>-->
                  <!--                          <span :class="account_recycle_letter===item?'active_A-Z':''" v-for="item in alphabet" :key="item" v-text="item" @click="getaccount_recycle_list(item)"></span>-->
                  <!--                        </div>-->
                  <!--                      </div>-->
                  <!--                    </div>-->

                  <!--                  </div>-->
                  <!--                  &lt;!&ndash;  热门服务 内容  &ndash;&gt;-->
                  <!--                  <div class="game_type_bullet_list">-->
                  <!--                    <div class="game_type_bullet_list_item" v-for="(item,index) in account_recycle_list" :key="index" :id="index % 6 !== 0 ?'line_not_first_item':''">-->
                  <!--                      <div class="game_type_bullet_list_item_img">-->
                  <!--                        <img :src="item.game_image" alt="">-->
                  <!--                      </div>-->
                  <!--                      <div class="game_type_bullet_list_item_text">{{item.game_name}}</div>-->
                  <!--                    </div>-->
                  <!--                  </div>-->
                  <!--                </div>-->
                </router-link>
              </div>
            </div>
          </div>
          <div class="header_first_mid">
            <el-carousel @change="getCarouselIndex">
              <el-carousel-item v-for="(item,index) in carouselList" :key="index">
                <h3 class="small">
                  <!--                  <img src="../../assets/image/Home/dailyTransactionItem.jpeg" alt="">-->
                  <img v-lazy="item.show_img" :alt="item.show_text" @click="clickCarousel(item)">
                </h3>
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="header_first_right">
            <div class="header_first_right_top">
              <div class="userInfo">
                <router-link v-if="this.$store.state.loginStatus" class="userInfo_img userInfo_profile_link" :to="{name:'PersonalCenter'}">
                  <!--                  <img src="../../assets/image/Home/userAvatar.jpeg" alt="">-->
                  <img v-if="this.$store.state.userData.touxiang && this.$store.state.userData.touxiang !== ''"
                       :src="this.$store.state.userData.touxiang" alt=""
                       @error="$event.target.src = require('@/assets/logo/logo.svg');$event.target.classList.add('default_avatar')">
                  <img v-else class="default_avatar" src="@/assets/logo/logo.svg" alt="">
                </router-link>
                <div v-else class="userInfo_img">
                  <!--                  <img src="../../assets/image/Home/userAvatar.jpeg" alt="">-->
                  <img v-if="this.$store.state.userData.touxiang && this.$store.state.userData.touxiang !== ''"
                       :src="this.$store.state.userData.touxiang" alt=""
                       @error="$event.target.src = require('@/assets/logo/logo.svg');$event.target.classList.add('default_avatar')">
                  <img v-else class="default_avatar" src="@/assets/logo/logo.svg" alt="">
                </div>
                <div class="userInfo_account">
                  <span v-if="this.$store.state.loginStatus" class="userInfo_account_top userInfo_profile_name" title="点击复制" @click="copyUserName">{{ this.$store.state.userData.nickname }}</span>
                  <span v-else class="userInfo_account_top">{{ this.$store.state.userData.nickname }}</span><br>
                  <span class="userInfo_account_bot" v-if="this.$store.state.loginStatus">
                    <router-link tag="span" :to="{name:'PersonalCenter'}">个人中心</router-link>
                    丨
                    <span class="logout_btn" @click="logout">退出</span>
                  </span>
                  <span class="userInfo_account_bot" v-if="!this.$store.state.loginStatus">
                    <router-link tag="span" :to="{name:'Login'}">登录</router-link>
                    丨
                    <router-link tag="span" :to="{name:'Register'}">注册</router-link>
                  </span>
                </div>
              </div>
              <div class="btn_ground">
                <router-link :to="{name:'AllGame'}" class="buyNumber">
                  <i class="el-icon-shopping-cart-2"></i>
                  <div>我要买</div>
                  <div class="help_wrapper">
                    <el-button type="text" @click.prevent="goHelp(278,9)"><i class="el-icon-question"></i>如何买号</el-button>
                  </div>
                </router-link>
<!--                                <router-link :to="{name:'AccountSell'}" class="sellNumber">-->
                <a class="sellNumber" @click="sellClick">
                  <i class="el-icon-price-tag"></i>
                  <div>我要卖</div>
<!--                                  </router-link>-->
                </a>
              </div>
            </div>
            <div class="verify">
              <div class="verify_head">
                <div class="verify_title_img">
                  <img src="@/assets/image/Home/verify.png" alt="">
                </div>
                <div class="verify_title_text">验证查询</div>
              </div>
              <div class="verify_cards">
                <router-link to="/cusserverify?type=1" class="verify_card"><span></span>客服<br/>验证</router-link>
                <router-link to="/blacknumverify" class="verify_card"><span></span>黑号<br/>查询</router-link>
                <router-link to="/cusserverify?type=2" class="verify_card"><span></span>账户<br/>验证</router-link>
              </div>
<!--              <el-tabs v-model="activeVerify">
                <el-tab-pane label="客服验证" name="cusserverify">
                  <router-link class="cusserverifyBtn" :to="{name:'CusSerVerify'}">点击验证</router-link>
                </el-tab-pane>
                <el-tab-pane label="黑号查询" name="blacknumverify">
                  <el-input placeholder="请输入账号" v-model.trim="blackNumVerify" class="blacknumverifyInput">
                    <router-link tag="el-button" slot="append" :to="{name:'BlackNumVerify',params:{num:blackNumVerify}}">
                      <img src="@/assets/image/Home/searchIco.png" alt="">
                    </router-link>
                  </el-input>
                </el-tab-pane>
              </el-tabs>-->
            </div>

            <div class="header_first_right_bottom">
              <div class="announcement_title">
                <div class="a_title_img">
                  <img src="@/assets/image/Home/announcement.png" alt="">
                </div>
                <div class="a_title_text">公告消息</div>
                <div @click="PCNoticeClick('更多','')">
                  <router-link tag="a" class="a_title_more" :to="{name:'Article',query:{cat_id:'1'}}">
                    更多
                    <i class="el-icon-arrow-right"></i>
                  </router-link>
                </div>

              </div>
              <div class="announcement_content">
                <div v-for="(item,index) in article_list.slice(0,3)" :key="index" @click="PCNoticeClick('公告标题',item.title)">
                  <router-link :to="{name:'Article',query:{cat_id:'1',id:item.id}}">
                    <span></span>
                    <div class="announcement_content_text">{{ item.title }}</div>
                  </router-link>
                </div>

              </div>
            </div>
          </div>
        </div>
        <div class="trade trade_seo" v-if="$route.query.seo == 1">
          <img class="trade_logo trade_seo_logo" src="@/assets/logo/logo_horizontal.svg" alt="游选">
          <div class="trade_seo_text">安全交易 · 法律保护 · 找回包赔</div>
        </div>
        <div class="trade" v-else>
          <div class="trade_statement">
            <img class="trade_logo" src="@/assets/logo/logo_horizontal.svg" alt="游选">
            <span class="trade_text">已帮助用户安全完成</span>
            <span class="trade_count">{{ tradeCount }}</span>
            <span class="trade_text">笔交易</span>
          </div>
          <div class="trade_meta">
            <span>当前在售号 <em>{{ inStock }}</em></span>
            <span>昨日访问量 <em>{{ views }}</em></span>
            <span>昨日成交量 <em>{{ toTrade }}</em></span>
          </div>
        </div>
        <div class="header_third">
          <div class="header_third_img">
            <i class="el-icon-message-solid"></i>
            <div>温馨提示：</div>
          </div>
          <div class="header_third_text">
            <div class="notice-card-wrapper">
              <span v-html="notice"></span>
            </div>
          </div>
        </div>
        <div class="header_four">
          <router-link :to="{name:'TradeTip',query:{id:'109',parent_id:'83'}}">
            <span class="tc-ic"><svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2l8 4v6c0 5-3.5 8-8 10-4.5-2-8-5-8-10V6z"/><path d="M9 12l2 2 4-4"/></svg></span>
            <span class="tc-eyebrow">LEGAL PROTECTION</span>
            <h3>签署合同 <em>法律保护</em></h3>
            <p>正规电子版合同 · 交易全程留痕可追溯</p>
            <span class="tc-no">01</span>
          </router-link>
          <router-link :to="{name:'Legal',query:{id:'15',parent_id:'13'}}">
            <span class="tc-ic"><svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12a9 9 0 1 1-3-6.7M21 3v5h-5"/><path d="M12 8v4l3 2"/></svg></span>
            <span class="tc-eyebrow">FULL REFUND</span>
            <h3>账号被找回 <em>全额赔付</em></h3>
            <p>售后保证 · 平台先行垫付不扯皮</p>
            <span class="tc-no">02</span>
          </router-link>
          <router-link to="/home/cusSerCenter">
            <span class="tc-ic"><svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M16 11a4 4 0 1 0-8 0M3 21v-1a5 5 0 0 1 5-5h8a5 5 0 0 1 5 5v1"/><circle cx="12" cy="7" r="3"/></svg></span>
            <span class="tc-eyebrow">3-PERSON SERVICE</span>
            <h3>三人专服 <em>服务至上</em></h3>
            <p>客服 + 担保 + 技术 全程护航交付</p>
            <span class="tc-no">03</span>
          </router-link>
        </div>
      </div>
    </div>
    <!--  首页内容  -->
    <div class="main_body">
      <div class="account_ground">
        <!--  顶级账号  -->
        <div class="top_account">
          <div class="top_account_title">
            <div class="top_account_title_logo">
              <span class="account_section_icon">
                <i class="el-icon-trophy"></i>
              </span>
              <span class="account_section_text">
                <strong>顶级<span>账号</span></strong>
                <em>TOP</em>
              </span>
            </div>
            <div class="top_account_title_list" ref="topAccountTabList" @wheel="handleAccountTabWheel">
              <span class="top_account_title_list_item" :id="topAccount_games_select===item.game_name?'active':''"
                    @click="clickTopAccountGames(item)"

                    v-for="(item,index) in topAccount_games" :key="index">
                {{ item.game_name }}
              </span>
              <span class="account_tab_indicator" :style="topTabIndicatorStyle"></span>
            </div>
            <router-link class="top_account_title_list_more"
                         :to="topAccount_games_select_id=='26'?{name:'SelectGame',query:{game_id:this.topAccount_games_select_id,game_alias:'yuanshen5'},
                         params:{game_name:this.topAccount_games_select,game_id:this.topAccount_games_select_id,game_class:this.topAccount_games_select_class,rec:'dingji',breadCrumbs:'顶级账号'}}
                         :{name:'SelectGame',query:{game_id:this.topAccount_games_select_id,game_alias:'games'},
                         params:{game_name:this.topAccount_games_select,game_id:this.topAccount_games_select_id,game_class:this.topAccount_games_select_class,rec:'dingji',breadCrumbs:'顶级账号'}}
">
              更多 <i class="el-icon-arrow-right"></i>
            </router-link>
          </div>
          <div class="top_account_content" v-if="!topAccountLoading && top_account_info.length">
            <a class="top_account_content_item" v-for="(item,index) in top_account_info" :key="index"
                 @click="topItemClick(item,index)">
              <div class="top_account_content_item_img">
                <!--                <img src="../../assets/image/Home/dailyTransactionItem.jpeg" alt="">-->
                <img v-lazy="item.image" />
              </div>
              <div class="top_account_content_item_info">
                <div class="top_account_content_item_info_top">
                  <span>{{ topAccount_games_select }}</span>
                  {{ item.name }}
                </div>
                <div class="top_account_content_item_info_bot">
                  <div id="top_account_info_left">
                    <div id="top_account_info_hot">
                      <img src="@/assets/image/Home/topGamesIco.png" alt="">
                      {{ item.click }}
                    </div>
                    <!-- <div id="top_account_info_date">
                      {{ item.up_time|moment }}
                    </div> -->
                  </div>
                  <div id="top_account_info_right" v-if="item.price > 0">
                    ¥<span>{{ item.price }}</span>
                  </div>

                </div>
              </div>
              <!-- 商品详情 -->
              <div class="top_account_content_item_detail">
                <!-- 商品详情标题 -->
                <div id="top_account_content_item_detail_title">商品详情</div>
                <!-- 商品详情内容 -->
                <div id="top_account_content_item_detail_content">
                  {{ item.name }}
                </div>
              </div>
            </a>
          </div>
          <div class="account_loading" v-else-if="topAccountLoading" v-loading="topAccountLoading"></div>
          <div class="account_empty" v-else>
            <empty-state title="暂无账号"></empty-state>
          </div>
        </div>
        <!--  最新账号  -->
        <div class="latest_account">
          <div class="latest_account_title">
            <div class="latest_account_title_logo">
              <span class="account_section_icon">
                <i class="el-icon-news"></i>
              </span>
              <span class="account_section_text">
                <strong>最新<span>账号</span></strong>
                <em>NEW</em>
              </span>
            </div>
            <div class="latest_account_title_list" ref="latestAccountTabList" @wheel="handleAccountTabWheel">
              <div class="latest_account_title_list_item" :id="newAccount_games_select===item.game_name?'active':''"
                   @click="clickNewAccountGames(item)"
                   v-for="(item,index) in newAccount_games" :key="index">
                {{ item.game_name }}
              </div>
              <span class="account_tab_indicator" :style="latestTabIndicatorStyle"></span>
            </div>
            <router-link  class="latest_account_title_list_more"
                         :to="newAccount_games_select_id=='26'?{name:'SelectGame',query:{game_id:this.newAccount_games_select_id,game_alias:'yuanshen5'},params:{game_name:this.newAccount_games_select,game_id:this.newAccount_games_select_id,game_class:this.newAccount_games_select_class,type:'new',breadCrumbs:'最新账号'}}
                         :{name:'SelectGame',query:{game_id:this.newAccount_games_select_id,game_alias:'games'},params:{game_name:this.newAccount_games_select,game_id:this.newAccount_games_select_id,game_class:this.newAccount_games_select_class,type:'new',breadCrumbs:'最新账号'}}">
              更多 <i class="el-icon-arrow-right"></i>
            </router-link>
          </div>
          <div class="latest_account_content" v-if="!latestAccountLoading && new_account_info.length">
            <div class="latest_account_content_item" v-for="(item,index) in new_account_info" :key="index"
                 @click="latestItemClick(item,index)">
              <div class="latest_account_content_item_img">
                <!--                <img src="../../assets/image/Home/dailyTransactionItem.jpeg" alt="">-->
                <img v-lazy="item.image" />
              </div>
              <div class="latest_account_content_item_info">
                <div class="latest_account_content_item_info_top">
                  <span>{{ newAccount_games_select }}</span>
                  {{ item.name }}
                </div>
                <div class="latest_account_content_item_info_bot">
                  <div id="latest_account_info_left">
                    <div id="latest_account_info_hot">
                      <img src="@/assets/image/Home/topGamesIco.png" alt="">
                      {{ item.click }}
                    </div>
                    <!-- <div id="latest_account_info_date">
                      {{ item.up_time|moment }}
                    </div> -->
                  </div>
                  <div class="sellSincerity">
                    <sell-sincerity v-show="item.is_willing == 1" class="sellSincerityCom"></sell-sincerity>
                    <div id="latest_account_info_right" v-if="item.price> 0">
                      ¥<span>{{ item.price }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 商品详情 -->
              <div class="latest_account_content_item_detail">
                <!-- 商品详情标题 -->
                <div id="latest_account_content_item_detail_title">商品详情</div>
                <!-- 商品详情内容 -->
                <div id="latest_account_content_item_detail_content">
                  {{ item.name }}
                </div>
              </div>
            </div>
          </div>
          <div class="account_loading" v-else-if="latestAccountLoading" v-loading="latestAccountLoading"></div>
          <div class="account_empty" v-else>
            <empty-state title="暂无账号"></empty-state>
          </div>
        </div>
      </div>
      <!--  每日成交  -->
      <div class="daily_transaction">
        <div class="daily_transaction_title">
          <div class="daily_transaction_title_logo">
            <span class="daily_transaction_title_icon">
              <i class="el-icon-data-line"></i>
            </span>
            <span class="daily_transaction_title_text">
              <strong>昨日<span>成交</span></strong>
              <em>DAILY</em>
            </span>
          </div>
          <router-link  class="daily_transaction_title_more"
                       :to="{path:'home/dailyTxDetails',query:{game_id:dailyTransaction[0].game_id,time:dailyTransaction[0].pay_time}}">
            更多
            <i class="el-icon-arrow-right"></i>
          </router-link>
          <!--          <div class="daily_transaction_title_more">-->
          <!--            更多-->
          <!--            <i class="el-icon-arrow-right"></i>-->
          <!--          </div>-->
        </div>
        <!--        <div class="daily_transaction_filter">-->
        <!--          <div class="daily_transaction_filter_title">-->
        <!--            <span></span>-->
        <!--            <span>{{ value.label }}</span>-->
        <!--          </div>-->
        <!--          <div class="daily_transaction_filter_select">-->
        <!--            <el-select :popper-append-to-body="false" v-model="value" placeholder="请选择" @change="selectChange">-->
        <!--              <el-option v-for="item in options" :key="item.value" :label="item.label"-->
        <!--                         :value="{value:item.value,label:item.label}"></el-option>-->
        <!--            </el-select>-->
        <!--          </div>-->
        <!--        </div>-->
        <div class="daily_transaction_content" v-if="dailyTransaction.length > 1">
          <a class="daily_transaction_content_item"
               :class="{'is-ranked': index < 3, 'rank-first': index === 0, 'rank-second': index === 1, 'rank-third': index === 2}"
               v-for="(item,index) in dailyTransaction" :key="index"
               @click="daily_Tx_CLick(item)">
            <span class="DTCI_no">{{ index + 1 > 9 ? (index + 1) : '0' + (index + 1) }}</span>
            <div class="DTCI_top" v-if="index < 3">
              <img v-if="index === 0" src="../../assets/image/Home/dailyTransactionTop1.png" alt="">
              <img v-if="index === 1" src="../../assets/image/Home/dailyTransactionTop2.png" alt="">
              <img v-if="index === 2" src="../../assets/image/Home/dailyTransactionTop3.png" alt="">
            </div>
            <div class="DTCI_img">
              <img v-lazy="item.img" alt="">
            </div>
            <div class="DTCI_content">
              <div class="DTCI_gameName">{{ item.game_name }}</div>
              <div class="DTCI_orderNum">
                <span>昨日成交</span>
                <strong>{{ item.count }}</strong>
                <span>单</span>
              </div>
              <div class="DTCI_date">
                <div id="DTCI_date">{{ item.pay_time|moment }}</div>
                <div id="DTCI_btn">查看详情<i class="el-icon-arrow-right"></i></div>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
    <SellPop :sellPop="sellPop"></SellPop>
    <el-dialog
      :visible.sync="bannerWxDialog"
      custom-class="bannerWxDialog"
      :show-close="false"
      width="303px"
      top="20vh"
      center>
        <span>
          <div class="banner-dia-main">
            <div class="banner-dia-top">
              企业微信
            </div>
            <div class="banner-dia-wx">
              <img src="@/assets/image/Home/bannerWx.png">
              <div class="banner-dia-c">
                <img src="@/assets/image/Home/copyright.png">
                金华博淳网络科技
                <i class="el-icon-arrow-right"></i>
              </div>
              <div class="banner-dia-sys">
                <img src="@/assets/image/Home/bannerSs.png">
                商务合作请扫码加V
              </div>
            </div>
          </div>
          <img class="banner-dia-close" src="@/assets/image/AccountDeal/close.png" @click="bannerWxDialog = false">
        </span>
    </el-dialog>
  </div>
</template>

<script>
import SellPop from './SellPop/index'
import EmptyState from '@/components/emptyState'
import {
  apiGameInfo,
  apiPTotal,
  apiDArticleList,
  apiProductTop,
  apiProductNew,
  apiGameList,
  apiDesktopIndex,
  apiShowList,
  apiLogout,
  apiCustomerSys,
  apiGameClass,
  apiYesterdayDeal,
  downloadCounter
} from '@/request/API';
import SellSincerity from '../AllGame/components/sellSincerity.vue';
import { IMDisconnect } from '../../util/im';

export default {
  components: {
    SellPop,
    EmptyState,
    SellSincerity
  },
  data() {
    return {
      // 招商轮播图对话框
      bannerWxDialog: false,
      appDownload:true,
      bitmap1: false,
      bitmap2: false,
      bitmap3: false,
      //客服服务中心
      cusSerCenter: false,
      //我要卖
      sellPop:false,
      //A-Z
      action: {
        gameTypeId: null,
        firstChar: "全部",
      },
      alphabet: [],
      //背景渐变色
      backgroundColor: [
        // 'linear-gradient(180deg, rgba(194, 190, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%)',
        // 'linear-gradient(180deg, rgba(200, 186, 175, 0.5) 0%, rgba(255, 255, 255, 0) 100%)',
        // 'linear-gradient(180deg, rgba(153, 157, 173, 0.5) 0%, rgba(255, 255, 255, 0) 100%)',
      ],
      // 遮罩层 网络游戏 列表
      game_click: '',
      game_letter: '全部',
      gameClass: [],
      game_list: [],
      game_listGold: [],
      game_listEquip: [],
      // 已安全完成***笔交易
      tradeCount: 0,
      // 当前在售号
      inStock: 0,
      // 昨日访问量
      views: 0,
      // 昨日成交量
      toTrade: 0,
      // 1F 顶级账号 游戏tabbar列表
      topAccount_games: [],
      //1F 顶级账号 tabbar选中
      topAccount_games_select: "天涯明月刀",
      topAccount_games_select_id: '',
      topAccount_games_select_class: '',
      topTabIndicator: {
        left: 0,
        width: 0,
        ready: false
      },
      //1F item
      top_account_info: [],
      topAccountLoading: true,
      // 2F 最新账号 游戏tabbar列表
      newAccount_games: [],
      //2F 最新账号 tabbar选中
      newAccount_games_select: "天涯明月刀",
      newAccount_games_select_id: '',
      newAccount_games_select_class: '',
      latestTabIndicator: {
        left: 0,
        width: 0,
        ready: false
      },
      //2F item
      new_account_info: [],
      latestAccountLoading: true,

      //温馨提示
      notice: "游选账号yxh8.com为您提供安全的游戏交易，切勿私下交易谨防诈骗。",
      //最新成交记录
      animate: true,
      //最新成交记录轮播列表
      marqueeList: [
        {id: '1', user_phone: '158*****7571', game_name: '天涯明月刀', deal_money: '123'},

      ],
      //客服验证
      cusSerVerify: '',
      //黑号验证
      blackNumVerify: '',
      //每日成交下拉框
      options: [],
      //每日成交下拉框选中
      value: '',
      //每日成交列表
      dailyTransaction: [{
        game_id: '',
        pay_time: ''
      }],
      //当前幻灯片列表
      carouselList: [
        {back_color: ''}
      ],
      //当前幻灯片索引
      carouselIndex: 0,
      //公告栏列表
      article_list: [],
      //验证
      activeVerify:'cusserverify'
    }
  },
  methods: {
    /**
     * @description: 我要买，找客服跳转帮助中心
     * @return {*}
     */
    goHelp(id,cat_id) {
      let newPage = this.$router.resolve({
        name: 'helpDetail',
        query: {
          id,
          cat_id
        }
      })
      window.open(newPage.href, '_blank')
    },
    //我要卖 点击事件
    escSellPop(bool) {
      this.sellPop = bool
    },
    // 遮罩层 网络游戏 列表
    getgame_list(item) {
      if (!item) {
        this.game_letter = '全部'
      } else {
        this.game_letter = item
      }
      if (item === '全部') {
        item = ''
      }
      this.game_list = []
      this.game_listGold = []
      this.game_listEquip = []
      apiGameList({
        class_id: this.game_click,
        game_letter: item,
      }).then(res => {
        res.data.forEach((item, index) => {
          item.game_service.forEach(gsItem => {
            switch (gsItem.id) {
              case 1:
                this.game_list.push(item)
                break;
              case 2:
                this.game_listEquip.push(item)
                break;
              case 3:
                this.game_listGold.push(item)
                break;
            }
          })
        })
      })
    },
    changeGame_click(data) {
      this.game_list = []
      this.game_listGold = []
      this.game_listEquip = []
      this.game_click = data
      this.game_letter = '全部'
      apiGameList({
        class_id: this.game_click,
      }).then(res => {
        res.data.forEach((item, index) => {
          item.game_service.forEach(gsItem => {
            switch (gsItem.id) {
              case 1:
                this.game_list.push(item)
                break;
              case 2:
                this.game_listEquip.push(item)
                break;
              case 3:
                this.game_listGold.push(item)
                break;
            }
          })
        })
      })
    },
    pc_game_item(item, index) {
      if (item.game_id == "26") {
        this.$router.push({
          path: 'selectGame',
          name: 'SelectGame',
          query: {
            game_id: item.game_id,
            game_alias: 'yuanshen5'
          },
          params: {
            game_name: item.game_name,
            game_class: item.game_class,
            game_id: item.game_id,
            productTypeSelect: index
          }
        })
      } else {
        this.$router.push({
          path: 'selectGame',
          name: 'SelectGame',
          query: {
            game_id: item.game_id
            , game_alias: 'games'
          },
          params: {
            game_name: item.game_name,
            game_class: item.game_class,
            game_id: item.game_id,
            productTypeSelect: index
          }
        })
      }

    },
    //热门服务item点击事件
    gameTypeListClick() {
      this.$message({
        center: true,
        type: "info",
        message: '开发中，敬请期待！'
      })
    },

    //我要卖 按钮 点击事件
    sellClick(){
      this.sellPop = true
    },
    copyUserName() {
      const username = this.$store.state.userData.nickname
      if (!username) {
        return
      }
      const input = document.createElement('input')
      input.value = username
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      this.$message({
        center: true,
        type: 'success',
        message: '复制成功'
      })
    },
    //每日成交下拉框监听事件
    selectChange(event) {
      apiYesterdayDeal({}).then(res => {
        this.dailyTransaction = res.data
      })
    },
    //最新成交记录函数
    showMarquee: function () {
      this.animate = true;
      setTimeout(() => {
        this.marqueeList.push(this.marqueeList[0]);
        this.marqueeList.shift();
        this.animate = false;
      }, 500)
    },
    // 1F 顶级账号tabbar选中
    clickTopAccountGames(item) {
      this.topAccountLoading = true
      this.topAccount_games_select = item.game_name
      this.topAccount_games_select_id = item.game_id
      this.topAccount_games_select_class = item.game_class
      this.$nextTick(() => {
        this.updateAccountTabIndicator('top')
      })
      apiProductTop({
        game_id: item.game_id,
        pageSize: 6
      }).then(res => {
        res.data.forEach((items,index)=>{
          this.$sensorsTrack.AccountShow(
            this.$route.name,
            0,
            `${item.game_alias}_${items.id}`,
            item.game_name,
            item.game_id,
            '',
            false,
            index + 1,
            items.id,
            '游戏账号',
            '',
            '',
            '',
            '',
            '',
          )
        })
        this.top_account_info = res.data
      }).finally(() => {
        this.topAccountLoading = false
      })
    },
    updateAccountTabIndicator(type) {
      const list = type === 'top' ? this.$refs.topAccountTabList : this.$refs.latestAccountTabList
      const indicator = type === 'top' ? this.topTabIndicator : this.latestTabIndicator
      if (!list) {
        indicator.ready = false
        return
      }
      const active = list.querySelector('#active')
      if (!active) {
        indicator.ready = false
        return
      }
      const width = Math.max(active.offsetWidth - 16, 24)
      indicator.left = active.offsetLeft + (active.offsetWidth - width) / 2
      indicator.width = width
      indicator.ready = true
    },
    updateAccountTabIndicators() {
      this.$nextTick(() => {
        this.updateAccountTabIndicator('top')
        this.updateAccountTabIndicator('latest')
      })
    },
    handleAccountTabWheel(event) {
      const target = event.currentTarget
      if (!target || target.scrollWidth <= target.clientWidth) {
        return
      }
      const delta = Math.abs(event.deltaY) >= Math.abs(event.deltaX) ? event.deltaY : event.deltaX
      if (!delta) {
        return
      }
      event.preventDefault()
      target.scrollLeft += delta
    },
    async getGameInfo(gameId = "") {
      return apiGameInfo({
        id: gameId
      }).then(res => {
        return res.data;
      });
    },
    // 1F 顶级账号 item 点击事件
    async topItemClick(item,index) {
      const gameInfo = await this.getGameInfo(this.topAccount_games_select_id)
      let routeUrl = this.$router.resolve({
        name: 'GameDetails',
        query: {
          game_id: this.topAccount_games_select_id,
          id: item.id,
          source_page: 'home'
        },
      });
      this.$sensorsTrack.AccountClick(
        this.$route.name,
        '',
        `${gameInfo.game_alias}_${item.id}`,
        this.topAccount_games_select,
        this.topAccount_games_select_id,
        item.user_id,
        '',
        index + 1,
        `${gameInfo.game_alias}_${item.id}`,
        '游戏账号',
        '',
        '',
        '',
        '',
        '',
      )
      window.open(routeUrl.href, '_blank');
    },
    // 2F 最新账号tabbar选中
    clickNewAccountGames(item) {
      this.latestAccountLoading = true
      this.newAccount_games_select = item.game_name
      this.newAccount_games_select_id = item.game_id
      this.newAccount_games_select_class = item.game_class
      this.$nextTick(() => {
        this.updateAccountTabIndicator('latest')
      })
      apiProductNew({
        game_id: item.game_id,
        pageSize: 6
      }).then(res => {
        res.data.forEach((items,index)=>{
          this.$sensorsTrack.AccountShow(
            this.$route.name,
            0,
            `${item.game_alias}_${items.id}`,
            item.game_name,
            item.game_id,
            '',
            false,
            index + 1,
            items.id,
            '游戏账号',
            '',
            '',
            '',
            '',
            '',
          )
        })
        this.new_account_info = res.data
      }).finally(() => {
        this.latestAccountLoading = false
      })
    },
    // 2F 最新账号 item 点击事件
    async latestItemClick(item,index) {
      const gameInfo = await this.getGameInfo(this.topAccount_games_select_id)
      let routeUrl = this.$router.resolve({
        name: 'GameDetails',
        query: {
          game_id: this.newAccount_games_select_id,
          id: item.id,
          source_page: 'home'
        },
      });
      this.$sensorsTrack.AccountClick(
        this.$route.name,
        '',
        `${gameInfo.game_alias}_${item.id}`,
        this.newAccount_games_select,
        this.newAccount_games_select_id,
        item.user_id,
        '',
        index + 1,
        `${gameInfo.game_alias}_${item.id}`,
        '游戏账号',
        '',
        '',
        '',
        '',
        '',
      )
      window.open(routeUrl.href, '_blank');
    },
    // 每日成交 item 点击事件
    daily_Tx_CLick(item) {
      this.$router.push({
        path: '/home/dailyTxDetails',
        name: 'DailyTxDetails',
        query: {
          game_id: item.game_id,
          time: item.pay_time,
        },
      })
    },
    /**
     * 轮播图回调函数
     * @param key1 目前激活的幻灯片的索引
     * @param key2 原幻灯片的索引
     */
    getCarouselIndex: function (key1, key2) {
      this.carouselIndex = key1
    },
    //轮播图点击事件
    clickCarousel(item) {
      this.$sensorsTrack.PCBannerClick(item.show_name,this.carouselList.findIndex(v=>v.show_name === item.show_name) + 1)
      if(item.show_name == "招商入驻"){
        this.bannerWxDialog = true
      } else {
        item.show_link ?
        window.open(item.show_link,'_black')
        : ''
      }
    },

    /**
     * 公告栏 - 神策埋点
     * @param click_type
     * @param notice_name
     */
    PCNoticeClick(click_type,notice_name){
      this.$sensorsTrack.PCNoticeClick(click_type,notice_name)
    },
    /**
     * 热门服务 - 神策埋点
     * @param first_button
     * @param second_button
     */
    PCHotServiceClick(first_button,second_button){
      this.$sensorsTrack.PCHotServiceClick(first_button,second_button)
    },

    //初始化首页数据
    onLoad() {
      //获取 当前在售号 && 今日访问量
      apiPTotal({}).then(res => {
        this.tradeCount = res.data.dealTotal
        this.inStock = res.data.saleTotal
        this.views = res.data.pv
        this.toTrade = res.data.yesterday
      })
      //获取 公告栏列表
      apiDArticleList({}).then(res => {
        this.article_list = res.data
      })
      //获取游戏列表
      apiGameList({}).then(res => {
        // this.game_list = res.data
        this.topAccount_games = res.data
        this.newAccount_games = res.data
        res.data.forEach((item, index) => {
          let options = new Object()
          options.value = item.game_id
          options.label = item.game_name
          if (index === 0) {
            this.value = options
            this.topAccount_games_select_id = item.game_id
            this.topAccount_games_select = item.game_name
            this.topAccount_games_select_class = item.game_class
            this.newAccount_games_select_id = item.game_id
            this.newAccount_games_select = item.game_name
            this.newAccount_games_select_class = item.game_class
            //获取 每日成交列表
            this.selectChange()
          }
          this.options.push(options)
          item.game_service?.forEach(gsItem => {
            switch (gsItem.id) {
              case 1:
                this.game_list.push(item)
                break;
              case 2:
                this.game_listEquip.push(item)
                break;
              case 3:
                this.game_listGold.push(item)
                break;
            }
          })
        })
        this.updateAccountTabIndicators()
        //获取 1F顶级帐号列表
        this.topAccountLoading = true
        apiProductTop({
          pageSize: 6,
          game_id: this.topAccount_games_select_id,
        }).then(res => {
          this.top_account_info = res.data
        }).finally(() => {
          this.topAccountLoading = false
        })
        //获取 2F最新帐号列表
        this.latestAccountLoading = true
        apiProductNew({
          pageSize: 6,
          game_id: this.newAccount_games_select_id,
        }).then(res => {
          this.new_account_info = res.data
        }).finally(() => {
          this.latestAccountLoading = false
        })
      })
      apiGameClass({}).then(res => {
        this.gameClass = res.data
      })
      // 轮播图
      apiShowList({}).then(res => {
        this.carouselList = res.data
      })
    },
    /**
     * 退出登录
     */
    logout() {
      //  推广连接需求用户退出后仍能使用channel_code
      let channel_code = sessionStorage.getItem('channel_code')

      if (this.$store.state.loginStatus) {
        apiLogout({
          refresh_token:localStorage.getItem('refresh_token')||''
        }).then(res => {
          IMDisconnect()
          this.$message({
            center: true,
            type: 'success',
            message: "退出成功"
          })
        }).catch(err => {
          this.$message({
            center: true,
            type: 'error',
            message: err.msg
          })
        })
      }
      this.$store.commit('del_token')
      this.$store.state.userData = {}
      this.$store.state.loginStatus = false
      sessionStorage.clear();

      if(channel_code) {
        sessionStorage.setItem('channel_code',channel_code)
      }
    },
    /**
     * 获取推广链接
     */
    getChannelCode() {
      let channel_code = this.$route?.query?.channel_code
      if(channel_code) {
        sessionStorage.setItem('channel_code',channel_code)
        downloadCounter({from:'homepage',channel_code:channel_code})
      }
    }
  },
  mounted() {

  },
  created() {
    if (this.$route.query?.seo == 1) {
      this.appDownload = false
    }
    this.getChannelCode()
    //最新交易记录
    setInterval(this.showMarquee, 2000)
    //A-Z
    for (var i = 0; i < 26; i++) {
      this.alphabet.push(String.fromCharCode(65 + i))
    }
    this.alphabet.unshift('全部')
    //遮罩层
    // this.getgame_list()
    //初始化首页数据
    this.onLoad()

    // this.getfirst_recharge_list()
    // this.getGold_list()
    // this.getaccount_recycle_list()
  },
  computed: {
    topTabIndicatorStyle() {
      return {
        width: `${this.topTabIndicator.width}px`,
        opacity: this.topTabIndicator.ready ? 1 : 0,
        transform: `translateX(${this.topTabIndicator.left}px)`
      }
    },
    latestTabIndicatorStyle() {
      return {
        width: `${this.latestTabIndicator.width}px`,
        opacity: this.latestTabIndicator.ready ? 1 : 0,
        transform: `translateX(${this.latestTabIndicator.left}px)`
      }
    }
  }
}

</script>

<style lang='less' scoped>
/deep/ .el-carousel .el-carousel--horizontal * {
  z-index: 1 !important;
}

/deep/ .el-carousel__container {
  height: 450px !important;
}
/deep/ .el-dialog__header{
  padding: 0;
  display: none;
}
/deep/.el-dialog--center .el-dialog__body{
  padding: 0;
}
#home {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100vw;

  .background {
    position: relative;
    width: 100vw;
    display: flex;
    justify-content: center;
    align-items: center;

    .bg-color {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      height: 520px;
      transition: background-color 0.2s;

      .mask {
        position: absolute;
        inset: 0;
        background: linear-gradient(to bottom, transparent 0%, var(--bg-page) 100%);
      }
    }

    //首页顶部
    .header {
      position: relative;
      width: 1200px;
      margin-top: 14px;
      //首页顶部第一层
      .header_first {
        height: 450px;
        display: flex;
        flex-direction: row;
        //热门服务
        .header_first_left {
          width: 243px;
          margin-right: 8px;
          height: 450px;
          box-sizing: border-box;
          position: relative;
          z-index: 5;
          display: flex;
          flex-direction: column;
          background: var(--bg-card);
          box-shadow: var(--shadow-card);
          border-radius: 4px;

          .header_first_left_top {
            flex: 0 0 60px;
            height: 60px;
            width: 243px;
            background: var(--bg-dark, #1A1D24);
            border-radius: 4px 4px 0 0;
            display: flex;
            flex-direction: row;
            align-items: center;

            .hot_service_img {
              width: 34px;
              height: 34px;
              margin-left: 24px;
              padding: 0 10px 0 0;

              img {
                height: 100%;
                width: 100%;
                object-fit: cover;
              }
            }

            .hot_service_text {
              font-size: 18px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 500;
              color: #FFFFFF;
              line-height: 25px;
            }
          }

          .header_first_left_bot {
            flex: 1;
            min-height: 0;
            width: 243px;
            background: #FFFFFF;
            border-radius: 0 0 4px 4px;
            display: flex;
            flex-direction: column;

            > div {
              flex: 1;
              min-height: 0;
            }

            .game_type_list {
              display: block;
              box-sizing: border-box;
              padding: 15px 18px 0 22px;
              height: 100%;
              cursor: pointer;
              position: relative;
              border-bottom: 1px solid var(--border-soft);

              &:hover::after {
                content: '';
                position: absolute;
                top: 0;
                right: -8px;
                width: 8px;
                height: 100%;
              }

              .type_name {
                display: flex;
                flex-direction: row;
                align-items: center;

                .service_icon {
                  flex-shrink: 0;
                  width: 36px;
                  height: 36px;
                  margin-right: 10px;
                  border-radius: 4px;
                  background: var(--bg-tag, #F0EDE8);
                  color: var(--text-main, #1A1D24);
                  box-shadow: inset 0 0 0 1px rgba(26, 29, 36, 0.08);
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  font-size: 20px;
                  transition: all ease .25s;
                }

                span {
                  font-size: 17px;
                  font-family: PingFangSC-Light, PingFang SC;
                  font-weight: 500;
                  color: var(--text-main);
                  width: 125px;
                }

                .el-icon-arrow-right {
                  flex-shrink: 0;
                  font-size: 15px;
                  color: var(--text-muted);
                }
              }

              .type_game {
                margin: 6px 0 0 46px;
                font-size: 15px;
                font-family: PingFangSC-Thin, PingFang SC;
                font-weight: 300;
                color: var(--text-muted);
                line-height: 21px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }

              .game_type_bullet {
                width: 697px;
                height: 450px;
                z-index: 80;
                position: absolute;
                padding: 22px 24px 20px;
                cursor: auto;
                background: linear-gradient(135deg, rgba(26, 29, 36, 0.96) 0%, rgba(26, 29, 36, 0.94) 100%);
                border-radius: 4px;
                box-shadow: 0 20px 40px rgba(26, 29, 36, 0.18);
                overflow: hidden;
                box-sizing: border-box;
                opacity: 0;
                visibility: hidden;
                pointer-events: none;
                transform: translateX(-8px) scale(.985);
                transform-origin: left center;
                transition: opacity .22s ease, transform .22s ease, visibility .22s ease;

                .game_type_bullet_title {
                  padding: 0;

                  .game_type_bullet_title_top {
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    align-items: center;
                    position: relative;
                    min-height: 38px;

                    img {
                      width: 50px;
                      height: 2px;
                      object-fit: cover;
                      position: absolute;
                      top: 34px;
                      left: 15px;
                    }

                    .bullet_title {
                      max-width: 560px;
                      font-size: 15px;
                      font-family: PingFangSC-Regular, PingFang SC;
                      font-weight: 400;
                      color: #FFFFFF;
                      line-height: 30px;
                      padding: 0;
                      background: none;
                      display: flex;
                      align-items: center;
                      flex-wrap: wrap;
                      gap: 8px;
                    }

                    .game_type_bullet_area {
                      flex-shrink: 0;
                      font-size: 14px;
                      font-family: PingFangSC-Thin, PingFang SC;
                      font-weight: 400;
                      color: #FFFFFF;
                      line-height: 30px;
                      opacity: .9;
                    }
                  }

                  .game_type_bullet_title_bot {
                    font-size: 12px;
                    font-family: PingFangSC-Light, PingFang SC;
                    font-weight: 400;
                    color: #FFFFFF;
                    line-height: 17px;

                    .opiton {
                      margin: 12px 0 0;
                      padding: 0 14px;
                      border-radius: 4px;
                      background: rgba(255, 255, 255, 0.12);
                      border: 1px solid rgba(255, 255, 255, 0.16);

                      div {
                        height: 34px;
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        justify-content: space-between;

                        span {
                          font-size: 12px;
                          font-family: PingFangSC-Light, PingFang SC;
                          font-weight: 500;
                          color: #FFFFFF;
                          line-height: 17px;
                          min-width: 18px;
                          text-align: center;
                          opacity: .84;
                        }

                        span:hover {
                          font-size: 12px;
                          font-family: PingFangSC-Light, PingFang SC;
                          font-weight: 500;
                          color: #FFFFFF;
                          line-height: 17px;
                          cursor: pointer;
                          opacity: 1;
                        }

                        .active_A-Z {
                          font-size: 12px;
                          font-family: PingFangSC-Light, PingFang SC;
                          font-weight: 600;
                          color: #FFFFFF;
                          line-height: 17px;
                          opacity: 1;
                        }
                      }
                    }
                  }
                }

                .game_type_bullet_list {
                  height: 324px;
                  margin: 18px -6px 0 0;
                  display: grid;
                  grid-template-columns: repeat(7, 1fr);
                  align-content: flex-start;
                  justify-items: center;
                  overflow: auto;
                  gap: 12px 10px;

                  .game_type_bullet_list_item {
                    width: 100%;
                    max-width: 78px;
                    height: 96px;
                    display: flex;
                    cursor: pointer;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    border-radius: 4px;
                    transition: all ease .2s;

                    .game_type_bullet_list_item_img {
                      width: 52px;
                      height: 52px;
                      overflow: hidden;
                      margin-bottom: 8px;
                      border-radius: 4px;
                      background: rgba(255, 255, 255, 0.16);

                      img {
                        height: 100%;
                        width: 100%;
                        object-fit: cover;
                        transition: 0.3s ease-in-out;
                        border-radius: 4px;
                      }
                    }

                    .game_type_bullet_list_item_text {
                      font-size: 14px;
                      font-family: PingFangSC-Thin, PingFang SC;
                      font-weight: 300;
                      color: #FFFFFF;
                      line-height: 20px;
                      overflow: hidden;
                      text-overflow: ellipsis;
                      white-space: nowrap;
                      width: 68px;
                      text-align: center;
                    }
                  }

                  .game_type_bullet_list_item:hover {
                    background: rgba(255, 255, 255, 0.12);

                    .game_type_bullet_list_item_img {
                      img {
                        height: 100%;
                        width: 100%;
                        //object-fit: cover;
                        transform: scale(1.1);
                      }
                    }
                  }

                  //每日成交 滚动条

                  #line_not_first_item {
                    margin-left: 0;
                  }
                }

                .game_type_bullet_list::-webkit-scrollbar-track{
                  border-radius: 4px;
                  background: transparent;
                }

                .game_type_bullet_list::-webkit-scrollbar{
                  width: 4px;
                  height: 4px;
                }

                .game_type_bullet_list::-webkit-scrollbar-thumb {
                  border-radius: 4px;
                  -webkit-box-shadow: inset 0 0 5px rgba(255, 255, 255, 0.2);
                  background: rgba(255, 255, 255, 0.28);
                }
              }

              .game {
                top: -60px;
                left: 251px;
                //display: block;
                .game_type_bullet_title {
                  .game_type_bullet_title_top {
                    .bullet_title {
                      background: none;

                      div {
                        margin: 0;
                        padding: 0 12px;
                        height: 30px;
                        border-radius: 4px;
                        font-size: 14px;
                        font-family: PingFangSC-Thin, PingFang SC;
                        font-weight: 400;
                        color: #FFFFFF;
                        cursor: pointer;
                        background: rgba(255, 255, 255, 0.1);
                        transition: all ease .2s;
                      }

                      .game_click {
                        background: rgba(255, 255, 255, 0.24);
                        font-size: 14px;
                        font-family: PingFangSC-Light, PingFang SC;
                        font-weight: 600;
                        color: #FFFFFF;
                      }

                      .game_type_bullet_area {
                        padding: 0 0 5px 0;
                      }

                      #pcGame {
                        padding: 0 0 5px 0;
                        margin: 0 40px 0 0;
                      }

                      #peGame {
                        padding: 0 0 5px 0;
                      }
                    }

                  }
                }
              }

              .first_recharge {
                top: -255px;
                left: 251px;
                //display: block;
                .game_type_bullet_title {
                  .game_type_bullet_title_top {
                    .bullet_title {
                      display: flex;
                      flex-direction: row;
                      flex-wrap: wrap;
                      gap: 8px;
                      background: none;

                      div {
                        margin: 0;
                        padding: 0 12px;
                        height: 30px;
                        border-radius: 4px;
                        font-size: 14px;
                        font-family: PingFangSC-Thin, PingFang SC;
                        font-weight: 400;
                        color: #FFFFFF;
                        cursor: pointer;
                        background: rgba(255, 255, 255, 0.1);
                        transition: all ease .2s;
                      }

                      .game_click {
                        background: rgba(255, 255, 255, 0.24);
                        font-size: 14px;
                        font-family: PingFangSC-Light, PingFang SC;
                        font-weight: 600;
                        color: #FFFFFF;
                      }

                      .game_type_bullet_area {
                        padding: 0 0 5px 0;
                      }

                      #pcGame {
                        padding: 0 0 5px 0;
                        margin: 0 40px 0 0;
                      }

                      #peGame {
                        padding: 0 0 5px 0;
                      }
                    }

                  }
                }
              }

              .gold {
                top: -352px;
                left: 251px;
                //display: block;
                .game_type_bullet_title {
                  .game_type_bullet_title_top {
                    .bullet_title {
                      display: flex;
                      flex-direction: row;
                      flex-wrap: wrap;
                      gap: 8px;
                      background: none;

                      div {
                        margin: 0;
                        padding: 0 12px;
                        height: 30px;
                        border-radius: 4px;
                        font-size: 14px;
                        font-family: PingFangSC-Thin, PingFang SC;
                        font-weight: 400;
                        color: #FFFFFF;
                        cursor: pointer;
                        background: rgba(255, 255, 255, 0.1);
                        transition: all ease .2s;
                      }

                      .game_click {
                        background: rgba(255, 255, 255, 0.24);
                        font-size: 14px;
                        font-family: PingFangSC-Light, PingFang SC;
                        font-weight: 600;
                        color: #FFFFFF;
                      }

                      .game_type_bullet_area {
                        padding: 0 0 5px 0;
                      }

                      #pcGame {
                        padding: 0 0 5px 0;
                        margin: 0 40px 0 0;
                      }

                      #peGame {
                        padding: 0 0 5px 0;
                      }
                    }

                  }
                }
              }

              //.gold{
              //  background:url("../../assets/image/Home/background3.png") no-repeat;
              //  top: -430px;
              //  left: 202px;
              //}
              //.account_recycle{
              //  background:url("../../assets/image/Home/background4.png") no-repeat;
              //  top: -553px;
              //  left: 202px;
              //  //display: block;
              //}
            }

            .game_type_list:hover {
              background: var(--bg-tag, #F0EDE8);
              z-index: 70;

              .service_icon {
                background: var(--bg-dark, #1A1D24);
                color: #FFFFFF;
                box-shadow: 0 8px 18px rgba(26, 29, 36, 0.18);
              }

              .game_type_bullet {
                opacity: 1;
                visibility: visible;
                pointer-events: auto;
                transform: translateX(0) scale(1);
              }
            }

            .game_type_bullet:hover {
              opacity: 1;
              visibility: visible;
              pointer-events: auto;
              transform: translateX(0) scale(1);
            }

            > div:last-child {
              .game_type_list {
                border-bottom: none;
                border-radius: 0 0 4px 4px;
              }
            }

            .first_recharge, .gold , .accountValuation {
              position: relative;

              .inDev {
                width: 268px;
                height: 158px;
                z-index: 3 !important;
                background: url("../../assets/image/Home/inDev.png") no-repeat;
                display: none;
                position: absolute;
                top: -30px;
                left: 220px;
                font-size: 14px;
                font-family: PingFangSC-Thin, PingFang SC;
                font-weight: 300;
                color: #9A9A9A;
                line-height: 20px;

                div {
                  display: flex;
                  align-items: flex-end;
                  flex-direction: row;
                  justify-content: center;
                  align-content: space-between;
                  height: 131px;
                  padding: 0 0 0 25px;
                }
              }
            }

            .first_recharge:hover, .gold:hover ,.accountValuation:hover {
              .inDev {
                display: block;
              }
            }

            .first_recharge {
              //background:url("../../assets/image/Home/background2.png") no-repeat;
              //top: -306px;
              //left: 202px;
            }
          }
        }

        //轮播图
        .header_first_mid {
          width: 697px;
          height: 450px;
          margin-right: 8px;
          border-radius: 4px;
          overflow: hidden;

          /deep/ .small {
            margin: 0;
            width: 697px;
            height: 450px;

            img {
              width: 100%;
              height: 100%;
              //object-fit: cover;
              border-radius: 4px;
            }
          }

          /deep/ .el-carousel,
          /deep/ .el-carousel__container {
            height: 450px;
            border-radius: 4px;
          }

          /deep/ .el-carousel__arrow:hover {
            color: var(--primary, #FF5A1F);
          }

          /deep/ .el-carousel__arrow {
            height: 53px;
            width: 53px;
            font-size: 24px;
          }

        }

        //个人信息
        .header_first_right {
          width: 243px;
          height: 450px;
          display: flex;
          flex-direction: column;
          float: left;

          .header_first_right_top {
            width: 243px;
            box-sizing: border-box;
            background: #FFFFFF;
            box-shadow: var(--shadow-card);
            border: 1px solid var(--border-soft);
            border-radius: 4px;
            padding: 16px 16px;
            margin: 0;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .userInfo {
              display: flex;
              align-items: center;
              flex-direction: row;
              flex: 1;
              min-height: 0;
              margin: 0 0 14px;

              .userInfo_img {
                flex-shrink: 0;
                height: 58px;
                width: 58px;
                margin: 0 12px 0 0;
                border-radius: 4px;
                background: var(--bg-tag, #F0EDE8);
                box-shadow: inset 0 0 0 1px rgba(26, 29, 36, 0.08);
                overflow: hidden;

                img {
                  height: 100%;
                  width: 100%;
                  object-fit: cover;
                  border-radius: 4px;
                }

                .default_avatar {
                  padding: 8px;
                  object-fit: contain;
                  box-sizing: border-box;
                }
              }

              .userInfo_account {
                min-width: 0;
                font-size: 14px;
                font-family: PingFangSC-Thin, PingFang SC;
                font-weight: 300;
                color: var(--text-secondary);

                .userInfo_account_top {
                  display: inline-block;
                  max-width: 136px;
                  font-size: 16px;
                  font-family: PingFangSC-Thin, PingFang SC;
                  font-weight: 500;
                  color: var(--text-main);
                  margin-bottom: 2px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }

                .userInfo_profile_name {
                  cursor: pointer;
                }

                .userInfo_account_bot {
                  span {
                    display: inline-flex;
                    align-items: center;
                    padding: 1px 4px;
                    border-radius: 4px;
                    transition: color .24s ease;
                    font-weight: 500;
                  }

                  span:hover {
                    cursor: pointer;
                    color: var(--primary, #FF5A1F);
                  }

                  .logout_btn:hover {
                    color: var(--primary);
                  }
                }

              }
            }

            .btn_ground {
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: space-between;
              flex: 0 0 48px;

              a, button {
                width: 101px;
                height: 48px;
                /*margin: 5px 20px;*/
                font-size: 16px;
                font-family: PingFangSC-Thin, PingFang SC;
                font-weight: 500;
                cursor: pointer;
                transition: transform .24s ease, box-shadow .24s ease, background-position .32s ease, color .24s ease;
                display: flex;
                justify-content: center;
                align-items: center;
                overflow: visible;

                > i {
                  font-size: 22px;
                  margin-right: 6px;
                  transition: transform .24s ease;
                }

                div {
                  display: inline-block;
                  margin: 0;
                }
              }

              .buyNumber {
                background: var(--primary, #FF5A1F);
                color: #FFFFFF;
                border-radius: 4px;
                border-style: none;
                position: relative;
                transition: background-color .2s ease, transform .24s ease, box-shadow .24s ease;

                &:hover::after {
                  content: '';
                  position: absolute;
                  left: 0;
                  top: 48px;
                  width: 101px;
                  height: 8px;
                }

                .help_wrapper{
                  position: absolute;
                  top: 48px;
                  left: 0;
                  display: none;
                  width: 112px;
                  min-height: 28px;
                  background: rgba(255,255,255,0.94);
                  border: 1px solid rgba(26, 29, 36, 0.12);
                  border-radius: 4px;
                  box-shadow: 0 8px 20px rgba(26, 29, 36, 0.12);
                  backdrop-filter: blur(8px);
                  margin: 0;
                  padding: 6px 10px;
                  box-sizing: border-box;
                  button{
                    font-size: 12px;
                    font-family: PingFang SC, PingFang SC-Regular;
                    font-weight: 500;
                    color: var(--text-main, #1A1D24);
                    width: auto;
                    height: 16px;
                    padding: 0;
                    margin: 0 0 0 18px;
                    line-height: 16px;
                    border-bottom: 1px solid rgba(26, 29, 36, 0.22);
                    position: relative;
                    border-radius: unset;
                    transition: color .2s ease, border-color .2s ease;
                    img,i{
                      width: 15px;
                      height: 15px;
                      position: absolute;
                      left: -20px;
                      top: -1px;
                      font-size: 16px;
                      color: var(--text-main, #1A1D24);
                    }
                  }
                }
                &:hover{
                  background: var(--primary-hover, #E84A12);
                  .help_wrapper{
                    margin: 0;
                    padding: 6px 10px;
                    display: block;
                    button{
                      &:hover{
                        color: #1A1D24;
                        border-color: rgba(26, 29, 36, 0.42);
                      }
                    }
                  }
                }

                .help_wrapper:hover {
                  display: block;
                }
              }

              .sellNumber {
                background: var(--bg-dark, #1A1D24);
                color: #FFFFFF;
                border-radius: 4px;
                border: 1px solid #363b45;
                transition: border-color .2s ease, color .2s ease, transform .24s ease, box-shadow .24s ease;

                &:hover {
                  border-color: var(--primary, #FF5A1F);
                  color: var(--primary, #FF5A1F);
                }
              }

              .Recycle {
                border-radius: 4px;
                background-color: #ffffff;
                border: 1px solid var(--bg-dark, #1A1D24);
                background: url('../../assets/image/Home/recycleIco.png') no-repeat left;
                background-position: 45px;
                div {
                  margin-left: 33px;
                }

              }

              a:hover {
                -webkit-box-shadow: 0 10px 20px rgba(26, 29, 36, 0.14);
                box-shadow: 0 10px 20px rgba(26, 29, 36, 0.14);
                -webkit-transform: translateY(-1px);
                transform: translateY(-1px);
                color: #FFFFFF;
                font-weight: 500;
              }

              .Recycle:hover {
                background: var(--bg-dark, #1A1D24) url('../../assets/image/Home/recycleIco_white.png') no-repeat left;
                background-position: 45px;

                div {
                  margin-left: 33px;
                  color: white;
                }
              }
            }

          }
   /*       .verify {
            background: linear-gradient(180deg,#ffffff, #ffffff 1%, #ffffff 100%);
            border-radius: 4px;
            box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.20);
            margin: 0 0 8px;
            padding: 19px 21px 16px;
            display: flex;
            justify-content: center;
            /deep/.el-tabs{
              display: flex;
              flex-direction: column;
              align-items: center;
            }
            /deep/.el-tabs__nav-wrap::after{
              background-color: #FFFFFF;
            }
            /deep/.el-tabs__item{
              height: 30px;
              line-height: 25px;
              font-size: 18px;
              font-family: PingFang SC, PingFang SC-Regular;
              font-weight: 400;
              color: #58606a;
            }
            /deep/.el-tabs__item.is-active{
              font-family: PingFang SC, PingFang SC-Medium;
              font-weight: 500;
              color: #F0EDE8;
            }
            /deep/.el-tabs__active-bar{
              background-color: #F0EDE8;
            }
            .cusserverifyBtn{
              display: inline-block;
              width: 200px;
              height: 41px;
              line-height: 41px;
              background: #e8eeff;
              border: 1.5px solid #F0EDE8;
              border-radius: 4px;
              font-size: 18px;
              font-family: PingFang SC, PingFang SC-Light;
              font-weight: 300;
              text-align: CENTER;
              color: #F0EDE8;
              cursor: pointer;
            }
            .blacknumverifyInput{
              width: 200px;
              height: 41px;
              border-radius: 4px;
              /deep/.el-input__inner{
                height: 41px;
                line-height: 41px;
                border: 1.5px solid #F7F5F2;
                border-radius: 4px 0 0 4px ;
              }
              /deep/.el-input-group__append{
                border: none;
                background: #F0EDE8;
                border-radius: 0 4px 4px 0;
                //padding: 0 22px;
              }
              /deep/.el-button{
                padding: 10px;
              }
            }
          }*/
          .verify{
            height: 130px;
            box-sizing: border-box;
            margin: 8px 0 0 0;
            padding: 10px 18px 12px;
            background: linear-gradient(180deg, var(--bg-tag, #F0EDE8) 0%, #FFFFFF 100%);
            border: 1px solid var(--border-soft);
            border-radius: 4px;
            box-shadow: var(--shadow-card);
            display: flex;
            flex-direction: column;
            .verify_head{
              border-bottom: 1px solid var(--border-soft);
              padding: 0 0 7px;
              display: flex;
              align-items: center;
              .verify_title_img{
                margin: 0 5px 0 0;
                img{
                  width: 22px;
                  height: 22px;
                }

              }
              .verify_title_text{
                font-size: 16px;
                font-family: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: var(--text-main, #1A1D24);
                line-height: 19px;
              }
            }
            .verify_cards{
              margin: 8px 0 0;
              display: flex;
              align-items: center;
              justify-content: space-between;
              flex: 1;
              gap: 0 6px;
              .verify_card{
                //padding: 13px 16px;
                flex: 1;
                height: 100%;
                background: #FFFFFF;
                border: 1px solid var(--border-soft);
                box-shadow: 0px 2px 8px 0px rgba(26, 29, 36, 0.06);
                border-radius: 4px;
                font-size: 13px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: var(--text-secondary);
                cursor: pointer;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                line-height: 18px;
                transition: border-color .22s ease, box-shadow .22s ease, color .22s ease, background .22s ease, transform .22s ease;
                span{
                  display: inline-block;
                  background: var(--primary, #FF5A1F);
                  width: 22px;
                  height: 3px;
                  border-radius: 2px;
                  margin: 0 0 4px 0 ;
                  transition: background .22s ease, width .22s ease;
                }
              }
              .verify_card:hover{
                border: 1px solid var(--primary, #FF5A1F);
                color: var(--text-main, #1A1D24);
                background: linear-gradient(180deg, #FFFFFF 0%, var(--bg-tag, #F0EDE8) 100%);
                box-shadow: 0 8px 18px rgba(26, 29, 36, 0.14);
              }
            }
          }
          .header_first_right_bottom {
            background: linear-gradient(180deg, var(--success-soft) 0%, #FFFFFF 100%);
            margin: 8px 0 0 0;
            flex: 1;
            box-sizing: border-box;
            box-shadow: var(--shadow-card);
            border: 1px solid var(--border-soft);
            border-radius: 4px;
            padding: 10px 18px 12px;

            .announcement_title {
              height: 32px;
              border-bottom: 1px solid var(--border-soft);
              display: flex;
              flex-direction: row;
              align-items: center;

              .a_title_img {
                margin: 0 3px 0 0;
              }

              .a_title_text {
                font-size: 16px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 500;
                color: #0F766E;
                line-height: 19px;
                margin: 0 54px 0 0;
              }

              .a_title_more {
                font-size: 14px;
                font-family: PingFangSC-Light, PingFang SC;
                font-weight: 400;
                color: #0F766E;
                line-height: 16px;
                cursor: pointer;
                transition: color .24s ease;
              }

              .a_title_more:hover {
                color: var(--primary);
              }
            }

            .announcement_content {
              display: flex;
              flex-direction: column;
              a {
                display: flex;
                align-items: center;
                margin: 7px 0 0 0;
                .announcement_content_text{
                  width: 185px;
                  height: 18px;
                  font-size: 14px;
                  font-family: PingFangSC-Light, PingFang SC;
                  font-weight: 300;
                  color: var(--text-secondary);
                  line-height: 18px;
                  overflow: hidden;
                  overflow:hidden;
                  text-overflow:ellipsis;
                  white-space:nowrap;
                }
                span{
                  margin: 0 5px 0 0 ;
                  flex-shrink: 0;
                  width: 6px;
                  height: 6px;
                  border-radius: 3px;
                  background: #0F766E;
                  display: inline-block;
                }
              }
            }
          }
        }
      }

      .trade {
        margin: 9px 0 0 0;
        width: 1200px;
        box-sizing: border-box;
        padding: 0;
        background: #FFFFFF;
        border: 1px solid rgba(26, 29, 36, 0.16);
        box-shadow: 0 12px 30px rgba(26, 29, 36, 0.14), inset 0 1px 0 rgba(255, 255, 255, 0.72);
        border-radius: 4px;
        overflow: hidden;
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .trade_statement {
          flex: 1;
          width: 100%;
          box-sizing: border-box;
          padding: 10px 32px 8px;
          background:
            radial-gradient(circle at 50% 46%, rgba(26, 29, 36, 0.22) 0%, rgba(26, 29, 36, 0.11) 30%, rgba(26, 29, 36, 0) 66%),
            linear-gradient(100deg, var(--bg-tag, #F0EDE8) 0%, #F7F5F2 48%, var(--bg-tag, #F0EDE8) 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          min-width: 0;

          .trade_logo {
            width: 118px;
            height: auto;
            margin: 0 16px 0 0;
            display: block;
            flex-shrink: 0;
          }

          .trade_text {
            font-size: 18px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: var(--text-secondary);
            line-height: 34px;
          }

          .trade_count {
            margin: 0 10px;
            font-size: 32px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 600;
            color: var(--primary);
            line-height: 36px;
          }
        }

        .trade_meta {
          flex: 0 0 40px;
          width: 100%;
          box-sizing: border-box;
          margin: 0;
          padding: 0 42px;
          background: linear-gradient(100deg, var(--bg-stage, #0E1116) 0%, var(--bg-dark, #1A1D24) 54%, var(--bg-stage, #0E1116) 100%);
          border-top: 1px solid rgba(26, 29, 36, 0.12);
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0;
          color: rgba(226, 232, 240, 0.72);
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          line-height: 40px;

          span {
            flex: 0 0 190px;
            text-align: center;
          }

          span + span {
            position: relative;
          }

          span + span::before {
            content: '';
            position: absolute;
            left: 0;
            top: 11px;
            width: 1px;
            height: 18px;
            background: rgba(255, 255, 255, 0.16);
          }

          em {
            margin-left: 5px;
            font-style: normal;
            font-weight: 500;
            color: #FFFFFF;
          }
        }
      }

      .trade_seo {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .trade_seo_logo {
          width: 130px;
          height: auto;
          margin: 0;
        }

        .trade_seo_text {
          margin: 8px 0 0;
          font-size: 16px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(226, 232, 240, 0.76);
          line-height: 24px;
        }
      }

      //首页顶部第二层
      .header_third {
        display: flex;
        align-items: center;
        height: 50px;
        margin-top: 9px;
        padding: 0 24px 0 28px;
        box-sizing: border-box;
        background: rgba(255, 255, 255, 0.94);
        border-radius: 4px;
        border: 1px solid var(--border-soft, #E8E4DE);
        box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
        width: 1200px;
        //小喇叭
        .header_third_img {
          flex: 0 0 auto;
          display: flex;
          align-items: center;
          margin: 0 18px 0 0;

          i {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            width: 30px;
            height: 30px;
            margin: 0 10px 0 0;
            border-radius: 50%;
            background: var(--bg-tag, #F0EDE8);
            color: var(--primary, #FF5A1F);
            font-size: 17px;
          }

          div {
            font-size: 15px;
            font-family: PingFangSC-Light, PingFang SC;
            font-weight: 500;
            color: var(--text-main, #111827);
            line-height: 22px;
            white-space: nowrap;
          }
        }

        //温馨提示内容
        .header_third_text {
          flex: 1;
          min-width: 0;
          line-height: 22px;
          font-size: 16px;
          font-family: PingFangSC-Light, PingFang SC;
          color: var(--text-secondary, #5A5F6B);
          overflow: hidden;

          .notice-card-wrapper {
            display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
            -webkit-line-clamp: 1; /*显示的行数；如果要设置2行加...则设置为2*/
            overflow: hidden; /*超出的文本隐藏*/
            text-overflow: ellipsis; /* 溢出用省略号*/
            -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
          }

          .notice-card-wrapper:hover {
            animation: myMove 30s linear infinite; // 重点，定义动画
            animation-fill-mode: forwards;
            width: 200%;
            @keyframes myMove {
              0% {
                transform: translateX(0);
              }
              100% {
                transform: translateX(-2500px);
              }
            }
          }
        }
      }

      //首页顶部第三层
      .header_four {
        margin: 10px 0 0 0;
        height: 200px;
        display: flex;
        align-items: stretch;
        justify-content: space-between;
        gap: 12px;

        a {
          flex: 1;
          min-width: 0;
          height: 200px;
          box-sizing: border-box;
          cursor: pointer;
          border-radius: 4px;
          border: 1px solid #1f242c;
          background: var(--bg-stage, #0E1116);
          overflow: hidden;
          position: relative;
          display: flex;
          flex-direction: column;
          justify-content: center;
          padding: 26px 28px;
          transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;

          .tc-ic {
            position: absolute;
            left: 28px;
            top: 24px;
            color: var(--primary, #FF5A1F);
            opacity: 0.9;
          }

          .tc-eyebrow {
            position: relative;
            margin-top: 40px;
            font-size: 11px;
            letter-spacing: 2px;
            color: var(--gold, #C9974D);
            font-weight: 700;
          }

          h3 {
            position: relative;
            color: #fff;
            font-size: 22px;
            font-weight: 900;
            letter-spacing: -0.5px;
            margin-top: 8px;

            em {
              font-style: normal;
              color: var(--primary, #FF5A1F);
            }
          }

          p {
            position: relative;
            color: #8b919c;
            font-size: 12px;
            margin-top: 8px;
          }

          .tc-no {
            position: absolute;
            right: 18px;
            bottom: -16px;
            font-style: italic;
            font-weight: 900;
            font-size: 92px;
            color: rgba(255, 255, 255, 0.05);
            line-height: 1;
          }
        }

        a:hover {
          transform: translateY(-3px);
          border-color: var(--primary, #FF5A1F);
          box-shadow: 0 14px 30px rgba(26, 29, 36, 0.18);
        }
      }
    }
  }


  //首页主体内容
  .main_body {
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    // 1F & 2F 左
    .account_ground {
      width: 898px;
      margin-right: 8px;
      position: relative;
      z-index: 2;

      .top_account {
        background: #FFFFFF;
        margin-bottom: 8px;
        display: flex;
        flex-direction: column;
        padding: 30px 37px 32px 42px;
        //1F 顶部列表
        .top_account_title {
          display: flex;
          flex-direction: row;
          margin-bottom: 32px;
          justify-content: space-between;

          .top_account_title_logo {
            width: 132px;
            height: 49px;

            img {
              height: 100%;
              width: 100%;
              object-fit: cover;
            }
          }

          .top_account_title_list {
            height: 38px;
            display: flex;
            flex-direction: row;
            padding: 0 2px;
            font-size: 15px;
            font-family: PingFangSC-Thin, PingFang SC;
            font-weight: 300;
            color: #000000;
            line-height: 38px;
            justify-content: space-between;
            white-space: nowrap;
            overflow-y: hidden;
            overflow-x: scroll;
            display: flex;

            .top_account_title_list_item {
              margin-right: 8px;
              cursor: pointer;
            }

            #active {
              font-size: 15px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 700;
              position: relative; //给当前元素添加相对定位,也就是after的父级
              &:after {
                content: " ";
                width: calc(100% - 16px);
                height: 3px;
                background: linear-gradient(90deg, var(--brand-blue, #1A1D24), var(--primary, #FF7A1A));
                position: absolute;
                bottom: -1px;
                left: 50%;
                transform: translateX(-50%);
                display: none;
              }
            }

          }

          .top_account_title_list::-webkit-scrollbar-track {
            //-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
            //border-radius: 4px;
            //background: rgba(0,0,0,0.1);
          }

          .top_account_title_list::-webkit-scrollbar  {
            width: 0;
            height: 0;
            display: none;
          }

          .top_account_title_list::-webkit-scrollbar-thumb  {
            border-radius: 4px;
            -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
            background: rgba(0, 0, 0, 0.1);
            display: none;
          }

          .top_account_title_list_more {
            display: flex;
            align-items: center;
            margin-left: 14px;
            font-size: 13px;
            font-family: PingFangSC-Thin, PingFang SC;
            font-weight: 400;
            color: var(--text-muted, #9AA0AC);
            line-height: 20px;
            cursor: pointer;
          }

          .top_account_title_list_more:hover {
            color: var(--primary, #FF5A1F);
          }
        }

        .top_account_title:hover {
          .top_account_title_list::-webkit-scrollbar-thumb{
            display: none;
          }
        }

        //1F 主体内容
        .top_account_content {
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          /*justify-content: space-between;*/

          .top_account_content_item {
            width: 266px;
            background: #FFFFFF;
            margin: 0 7px 9px 0;
            cursor: pointer;
            border: 1px solid var(--border-soft, #E8E4DE);
            border-radius: 4px;
            overflow: hidden;
            transition: border-color .2s var(--ease, ease), box-shadow .2s var(--ease, ease), transform .2s var(--ease, ease);

            .top_account_content_item_img {
              height: 174px;
              border-radius: 4px 4px 0 0;
              background: var(--bg-stage, #0E1116);
              overflow: hidden;
              img {
                height: 100%;
                width: 100%;
                object-fit: cover;
                border-radius: 4px 4px 0 0;
                transition: transform .3s var(--ease, cubic-bezier(.22,.9,.24,1));
              }
            }

            .top_account_content_item_info {
              padding: 14px 17px 17px 19px;
              border-radius: 0 0 4px 4px;
              background: #FFFFFF;

              .top_account_content_item_info_top {
                width: 226px;
                height: 67px;
                font-size: 16px;
                font-family: PingFangSC-Thin, PingFang SC;
                font-weight: 300;
                color: #5B5B5B;
                line-height: 22px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 3;
                overflow: hidden;
                margin-bottom: 10px;
                text-align: justify; /*实现两端对齐*/
                text-justify: newspaper; /*通过增加或减少字或字母之间的空格对齐文本*/
                word-break: break-all; /*允许在单词内换行*/

                span {
                  border-radius: 2px;
                  border: 0;
                  font-size: 12px;
                  font-family: PingFangSC-Medium, PingFang SC;
                  font-weight: 600;
                  color: var(--text-secondary, #5A5F6B);
                  background: var(--bg-tag, #F0EDE8);
                  line-height: 20px;
                  padding: 2px 8px;
                }
              }

              .top_account_content_item_info_bot {
                display: flex;
                flex-direction: row;
                align-items: baseline;
                justify-content: space-between;
                height: 42px;

                #top_account_info_left {
                  display: flex;
                  flex-direction: column;

                  #top_account_info_hot {
                    font-size: 14px;
                    font-family: PingFangSC-Thin, PingFang SC;
                    font-weight: 300;
                    color: #5B5B5B;
                    line-height: 20px;

                    img {
                      width: 17px;
                      height: 18px;
                      object-fit: cover;
                    }

                  }

                  #top_account_info_date {
                    font-size: 14px;
                    font-family: PingFangSC-Thin, PingFang SC;
                    font-weight: 300;
                    color: #8F8F8F;
                    line-height: 20px;
                  }
                }

                #top_account_info_right {
                  font-size: 15px;
                  font-family: PingFangSC-Semibold, PingFang SC;
                  font-weight: 900;
                  color: var(--primary, #FF5A1F);
                  height: 42px;

                  span {
                    font-size: 30px;
                    line-height: 42px;
                    font-weight: 900;
                    letter-spacing: -0.5px;
                  }
                }
              }
            }

            .top_account_content_item_detail {
              display: none;
              width: 458px;
              height: 295px;
              background: #FFFFFF;
              box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.2);
              border-radius: 0 4px 4px 0;
              position: absolute;
              top: 0px;
              left: 256px;
              padding: 16px 18px;

              #top_account_content_item_detail_title {
                display: flex;
                align-items: center;
                height: 28px;
                font-size: 16px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 600;
                color: var(--brand-blue, #1A1D24);
                line-height: 22px;
                margin-bottom: 8px;
                padding-bottom: 0;
                border-bottom: 0;
                box-sizing: border-box;
              }

              #top_account_content_item_detail_content {
                font-size: 14px;
                font-family: PingFangSC-Thin, PingFang SC;
                font-weight: 300;
                color: #5B5B5B;
                line-height: 20px;
                width: 448px;
                height: 260px;
                overflow: hidden;
              }
            }
          }

          .top_account_content_item:hover {
            border-color: var(--primary, #FF5A1F);
            box-shadow: 0 8px 22px rgba(26, 29, 36, 0.1);
            transform: translateY(-3px);
            position: relative;
            z-index: 9;

            .top_account_content_item_img img {
              transform: scale(1.05);
            }

            .top_account_content_item_detail {
              display: none !important;
            }
          }
        }
      }

      .latest_account {
        background: #FFFFFF;
        display: flex;
        flex-direction: column;
        padding: 30px 37px 32px 42px;
        //2F 顶部列表
        .latest_account_title {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          margin-bottom: 32px;

          .latest_account_title_logo {
            width: 147px;
            height: 46px;

            img {
              height: 100%;
              width: 100%;
              object-fit: cover;
            }
          }

          .latest_account_title_list {
            height: 38px;
            display: flex;
            flex-direction: row;
            padding: 0 2px;
            font-size: 16px;
            font-family: PingFangSC-Thin, PingFang SC;
            font-weight: 300;
            color: #000000;
            line-height: 38px;
            display: flex;
            justify-content: space-between;
            white-space: nowrap;
            overflow-x: scroll;
            overflow-y: hidden;

            .latest_account_title_list_item {
              margin-right: 8px;
              cursor: pointer;
            }

            #active {
              font-size: 15px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 700;
              position: relative; //给当前元素添加相对定位,也就是after的父级
              &:after {
                content: " ";
                width: calc(100% - 16px);
                height: 3px;
                background: linear-gradient(90deg, var(--brand-blue, #1A1D24), var(--primary, #FF7A1A));
                position: absolute;
                bottom: -1px;
                left: 50%;
                transform: translateX(-50%);
                display: none;
              }
            }
          }

          .latest_account_title_list::-webkit-scrollbar-track{
            //-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
            //border-radius: 4px;
            //background: rgba(0,0,0,0.1);
          }

          .latest_account_title_list::-webkit-scrollbar  {
            width: 0;
            height: 0;
            display: none;
          }

          .latest_account_title_list::-webkit-scrollbar-thumb {
            border-radius: 4px;
            -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
            background: rgba(0, 0, 0, 0.1);
            display: none;
          }

          .latest_account_title_list_more {
            margin-left: 14px;
            display: flex;
            align-items: center;
            font-size: 13px;
            font-family: PingFangSC-Thin, PingFang SC;
            font-weight: 400;
            color: var(--text-muted, #9AA0AC);
            line-height: 20px;
            cursor: pointer;
          }

          .latest_account_title_list_more:hover {
            color: var(--primary, #FF5A1F);
          }
        }

        .latest_account_title:hover {
          .latest_account_title_list::-webkit-scrollbar-thumb {
            display: none;
          }
        }

        //2F 主体内容
        .latest_account_content {
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          /*justify-content: space-between;*/

          .latest_account_content_item {
            width: 266px;
            background: #FFFFFF;
            margin: 0 7px 9px 0;
            cursor: pointer;
            border: 1px solid var(--border-soft, #E8E4DE);
            border-radius: 4px;
            overflow: hidden;
            transition: border-color .2s var(--ease, ease), box-shadow .2s var(--ease, ease), transform .2s var(--ease, ease);

            .latest_account_content_item_img {
              height: 174px;
              border-radius: 4px 4px 0 0;
              background: var(--bg-stage, #0E1116);
              overflow: hidden;
              img {
                height: 100%;
                width: 100%;
                object-fit: cover;
                border-radius: 4px 4px 0 0;
                transition: transform .3s var(--ease, cubic-bezier(.22,.9,.24,1));
              }
            }

            .latest_account_content_item_info {
              padding: 14px 17px 17px 19px;
              border-radius: 0 0 4px 4px;
              background: #FFFFFF;

              .latest_account_content_item_info_top {
                width: 226px;
                height: 67px;
                font-size: 16px;
                font-family: PingFangSC-Thin, PingFang SC;
                font-weight: 300;
                color: #5B5B5B;
                line-height: 22px;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 3;
                overflow: hidden;
                margin-bottom: 10px;
                text-align: justify; /*实现两端对齐*/
                text-justify: newspaper; /*通过增加或减少字或字母之间的空格对齐文本*/
                word-break: break-all; /*允许在单词内换行*/

                span {
                  border-radius: 2px;
                  border: 0;
                  font-size: 12px;
                  font-family: PingFangSC-Medium, PingFang SC;
                  font-weight: 600;
                  color: var(--text-secondary, #5A5F6B);
                  background: var(--bg-tag, #F0EDE8);
                  line-height: 20px;
                  padding: 2px 8px;
                }
              }

              .latest_account_content_item_info_bot {
                display: flex;
                flex-direction: row;
                align-items: baseline;
                justify-content: space-between;
                height: 42px;

                #latest_account_info_left {
                  display: flex;
                  flex-direction: column;
                  align-self: center;

                  #latest_account_info_hot {
                    font-size: 14px;
                    font-family: PingFangSC-Thin, PingFang SC;
                    font-weight: 300;
                    color: #5B5B5B;
                    line-height: 20px;

                    img {
                      width: 17px;
                      height: 18px;
                      object-fit: cover;
                    }

                  }

                  #latest_account_info_date {
                    font-size: 14px;
                    font-family: PingFangSC-Thin, PingFang SC;
                    font-weight: 300;
                    color: #8F8F8F;
                    line-height: 20px;
                  }
                }
                .sellSincerity{
                  display: flex;
                  justify-content: flex-end;
                  align-items: center;
                  .sellSincerityCom{
                    margin: 0 5px -5px 0;
                  }
                }

                #latest_account_info_right {
                  font-size: 15px;
                  font-family: PingFangSC-Semibold, PingFang SC;
                  font-weight: 900;
                  color: var(--primary, #FF5A1F);

                  span {
                    font-size: 30px;
                    line-height: 42px;
                    font-weight: 900;
                    letter-spacing: -0.5px;
                  }
                }
              }
            }

            .latest_account_content_item_detail {
              display: none;
              width: 458px;
              height: 295px;
              background: #FFFFFF;
              box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.2);
              border-radius: 0 4px 4px 0;
              position: absolute;
              top: 0px;
              left: 256px;
              padding: 16px 18px;

              #latest_account_content_item_detail_title {
                display: flex;
                align-items: center;
                height: 28px;
                font-size: 16px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 600;
                color: var(--brand-blue, #1A1D24);
                line-height: 22px;
                margin-bottom: 8px;
                padding-bottom: 0;
                border-bottom: 0;
                box-sizing: border-box;
              }

              #latest_account_content_item_detail_content {
                font-size: 14px;
                font-family: PingFangSC-Thin, PingFang SC;
                font-weight: 300;
                color: #5B5B5B;
                line-height: 20px;
                width: 448px;
                height: 260px;
                overflow: hidden;
              }
            }
          }

          .latest_account_content_item:hover {
            border-color: var(--primary, #FF5A1F);
            box-shadow: 0 8px 22px rgba(26, 29, 36, 0.1);
            transform: translateY(-3px);
            position: relative;
            z-index: 9;

            .latest_account_content_item_img img {
              transform: scale(1.05);
            }

            .latest_account_content_item_detail {
              display: none !important;
            }
          }
        }
      }

      .top_account,
      .latest_account {
        background: var(--bg-card, #FFFFFF);
        border: 1px solid var(--border-soft, #E8E4DE);
        box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
        border-radius: 4px;
        box-sizing: border-box;
        overflow: visible;
      }

      .account_empty,
      .account_loading {
        min-height: 200px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 24px 0 32px;
      }

      .account_loading {
        position: relative;
        pointer-events: none;
      }

      .top_account {
        margin-bottom: 12px;
      }

      .top_account_title,
      .latest_account_title {
        display: flex;
        align-items: center;
        gap: 16px;
        min-height: auto;
        margin: 0 0 20px;
        padding: 0;
        box-sizing: border-box;
        border: 0;
        border-radius: 0;
        background: transparent;
        position: relative;
        overflow: visible;

        .top_account_title_logo,
        .latest_account_title_logo {
          width: auto;
          height: auto;
          display: flex;
          align-items: center;
          gap: 9px;
          flex-shrink: 0;
          position: relative;
          z-index: 1;
          padding-bottom: 8px;

          /* 标题下橙色重点线 */
          &::after {
            content: '';
            position: absolute;
            left: 43px;
            bottom: 0;
            width: 46px;
            height: 3px;
            background: var(--primary, #FF5A1F);
          }

          .account_section_icon {
            flex-shrink: 0;
            width: 34px;
            height: 34px;
            border-radius: 3px;
            background: var(--bg-dark, #1A1D24);
            color: var(--primary, #FF5A1F);
            display: inline-flex;
            align-items: center;
            justify-content: center;
            transform: skewX(-12deg);

            i {
              transform: skewX(12deg);
              font-size: 18px;
            }
          }

          .account_section_text {
            flex-shrink: 0;
            display: flex;
            align-items: baseline;
            gap: 8px;
            white-space: nowrap;

            strong {
              font-size: 21px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 900;
              letter-spacing: -0.5px;
              color: var(--text-main, #1A1D24);
              line-height: 1;
              white-space: nowrap;

              span {
                color: var(--primary, #FF5A1F);
              }
            }

            em {
              font-size: 11px;
              letter-spacing: 2px;
              font-style: normal;
              font-weight: 700;
              color: var(--text-muted, #9AA0AC);
              line-height: 1;
            }
          }
        }

        .top_account_title_list,
        .latest_account_title_list {
          width: 530px;
          height: 38px;
          padding: 0 2px 0 9px;
          align-items: center;
          color: var(--text-secondary, #5A5F6B);
          background: transparent;
          border: 0;
          border-bottom: 1px solid rgba(227, 234, 246, 0.9);
          border-radius: 0;
          font-size: 15px;
          line-height: 38px;
          gap: 10px;
          justify-content: flex-start;
          overflow-x: auto;
          overflow-y: hidden;
          scrollbar-width: none;
          -ms-overflow-style: none;
          position: relative;
          z-index: 1;

          &::-webkit-scrollbar {
            width: 0;
            height: 0;
            display: none;
          }

          .top_account_title_list_item,
          .latest_account_title_list_item {
            flex-shrink: 0;
            height: 34px;
            margin-right: 8px;
            padding: 0 16px;
            display: flex;
            align-items: center;
            border-radius: 0;
            position: relative;
            z-index: 0;
            color: var(--text-secondary, #5A5F6B);
            font-size: 14px;
            font-weight: 700;
            cursor: pointer;
            transition: color .2s ease;

            /* 斜切平行四边形底（文字正立） */
            &::before {
              content: '';
              position: absolute;
              inset: 0;
              background: var(--bg-tag, #F0EDE8);
              transform: skewX(-12deg);
              border-radius: 2px;
              z-index: -1;
              transition: background .2s ease;
            }
          }

          .top_account_title_list_item:hover,
          .latest_account_title_list_item:hover {
            color: var(--text-main, #1A1D24);
          }

          .top_account_title_list_item:hover::before,
          .latest_account_title_list_item:hover::before {
            background: var(--border-soft, #E8E4DE);
          }

          /* 激活态：深炭斜切底 + 底部橙能量条 */
          #active {
            color: #FFFFFF;
            font-weight: 700;

            &::before {
              background: var(--bg-dark, #1A1D24);
            }

            &::after {
              content: '';
              display: block;
              position: absolute;
              inset: 0;
              background: transparent;
              border-bottom: 3px solid var(--primary, #FF5A1F);
              border-radius: 2px;
              transform: skewX(-12deg);
              z-index: 1;
              pointer-events: none;
            }
          }

          .account_tab_indicator {
            display: none;
          }
        }

        .top_account_title_list_more,
        .latest_account_title_list_more {
          flex-shrink: 0;
          margin-left: 14px;
          padding: 0;
          border-radius: 0;
          display: inline-flex;
          align-items: center;
          gap: 2px;
          color: var(--text-muted, #9AA0AC);
          background: transparent;
          box-shadow: none;
          font-size: 13px;
          font-weight: 400;
          font-family: PingFangSC-Thin, PingFang SC;
          line-height: 20px;
          white-space: nowrap;
          position: relative;
          z-index: 1;
          transition: color .2s ease;

          i {
            margin-left: 0;
            font-size: 11px;
            transition: transform .2s ease;
          }
        }

        .top_account_title_list_more:hover,
        .latest_account_title_list_more:hover {
          color: var(--primary, #FF5A1F);
          background: transparent;
          box-shadow: none;

          i {
            transform: translateX(2px);
          }
        }
      }

      .top_account_content,
      .latest_account_content {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 14px 13px;
        position: relative;

        .top_account_content_item,
        .latest_account_content_item {
          width: 100%;
          min-width: 0;
          box-sizing: border-box;
          margin: 0;
          border: 1px solid var(--border-soft, #E8E4DE);
          border-radius: 4px;
          background: #FFFFFF;
          box-shadow: 0 6px 18px rgba(26, 29, 36, 0.06);
          overflow: visible;
          position: relative;
          transition: transform .22s ease, border-color .22s ease, box-shadow .22s ease;

          &::before {
            content: '';
            position: absolute;
            top: 14px;
            bottom: 14px;
            left: 0;
            width: 3px;
            border-radius: 0 4px 4px 0;
            background: transparent;
            transition: background .22s ease, opacity .22s ease;
          }

          .top_account_content_item_img,
          .latest_account_content_item_img {
            height: 172px;
            border-radius: 0;
            box-shadow: none;
            background: var(--bg-stage, #0E1116);
            overflow: hidden;

            img {
              border-radius: 0;
              object-fit: cover;
              transition: transform .28s ease, filter .28s ease;
            }
          }

          .top_account_content_item_info,
          .latest_account_content_item_info {
            min-height: 134px;
            box-sizing: border-box;
            padding: 14px 16px 16px;
            border-radius: 0;
            box-shadow: none;
            background: #FFFFFF;

            .top_account_content_item_info_top,
            .latest_account_content_item_info_top {
              width: 100%;
              height: 68px;
              margin-bottom: 12px;
              color: var(--text-main, #111827);
              font-size: 15px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 500;
              line-height: 23px;
              text-align: left;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 3;
              overflow: hidden;
              word-break: break-all;

              span {
                display: inline-flex;
                vertical-align: 1px;
                max-width: 96px;
                height: 20px;
                align-items: center;
                border: 0;
                border-radius: 4px;
                padding: 0 8px;
                margin-right: 6px;
                background: var(--bg-tag, #F0EDE8);
                color: var(--text-main, #1A1D24);
                font-size: 12px;
                font-weight: 400;
                line-height: 20px;
                box-shadow: inset 0 0 0 1px rgba(26, 29, 36, 0.08);
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }

            .top_account_content_item_info_bot,
            .latest_account_content_item_info_bot {
              height: 36px;
              align-items: center;

              #top_account_info_left,
              #latest_account_info_left {
                align-self: center;

                #top_account_info_hot,
                #latest_account_info_hot {
                  display: inline-flex;
                  align-items: center;
                  height: 24px;
                  padding: 0 8px;
                  border-radius: 4px;
                  background: var(--bg-card-soft, #F0EDE8);
                  color: var(--text-secondary, #5A5F6B);
                  font-size: 13px;
                  line-height: 24px;

                  img {
                    flex-shrink: 0;
                    width: 14px;
                    height: 14px;
                    margin-right: 4px;
                    object-fit: contain;
                  }
                }
              }

              #top_account_info_right,
              #latest_account_info_right {
                display: inline-flex;
                align-items: baseline;
                justify-content: flex-end;
                height: 36px;
                color: var(--primary, #FF7A1A);
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 600;
                line-height: 36px;
                white-space: nowrap;
                letter-spacing: 0;

                span {
                  margin-left: 1px;
                  font-size: 24px;
                  font-weight: 900;
                  line-height: 36px;
                  letter-spacing: -0.5px;
                }
              }
            }
          }

          .top_account_content_item_detail,
          .latest_account_content_item_detail {
            display: none !important;
            width: 428px;
            height: 306px;
            box-sizing: border-box;
            background: #FFFFFF;
            border: 1px solid var(--border-soft, #E8E4DE);
            box-shadow: 0 16px 32px rgba(26, 29, 36, 0.14);
            border-radius: 0 4px 4px 0;
            position: absolute;
            top: -1px;
            left: calc(100% - 8px);
            right: auto;
            padding: 16px 18px;
            z-index: 30;
            opacity: 0;
            visibility: hidden;
            pointer-events: none;
            transform: translateX(-10px);
            transition: opacity .2s ease, transform .22s ease, visibility 0s linear .22s;

            &::before {
              content: '';
              position: absolute;
              left: -1px;
              top: 18px;
              bottom: 18px;
              width: 3px;
              border-radius: 0 4px 4px 0;
              background: var(--brand-blue, #1A1D24);
            }

            #top_account_content_item_detail_title,
            #latest_account_content_item_detail_title {
              display: flex;
              align-items: center;
              height: 28px;
              font-size: 16px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 600;
              color: var(--brand-blue, #1A1D24);
              line-height: 22px;
              margin-bottom: 8px;
              padding-bottom: 0;
              border-bottom: 0;
              box-sizing: border-box;
            }

            #top_account_content_item_detail_content,
            #latest_account_content_item_detail_content {
              width: auto;
              height: 250px;
              color: var(--text-secondary, #5A5F6B);
              font-size: 14px;
              font-family: PingFangSC-Light, PingFang SC;
              font-weight: 300;
              line-height: 22px;
              overflow: hidden;
            }
          }
        }

        .top_account_content_item:nth-child(3n),
        .latest_account_content_item:nth-child(3n) {
          .top_account_content_item_detail,
          .latest_account_content_item_detail {
            left: auto;
            right: calc(100% - 8px);
            border-radius: 4px 0 0 4px;
            transform: translateX(10px);

            &::before {
              left: auto;
              right: -1px;
              border-radius: 4px 0 0 4px;
            }
          }
        }

        .top_account_content_item:hover,
        .latest_account_content_item:hover {
          transform: translateY(-4px);
          border-color: var(--primary, #FF5A1F);
          box-shadow: 0 12px 24px rgba(26, 29, 36, 0.12);
          animation: none;
          z-index: 20;

          &::before {
            background: var(--brand-blue, #1A1D24);
            opacity: .9;
          }

          .top_account_content_item_img,
          .latest_account_content_item_img {
            img {
              transform: scale(1.045);
              filter: saturate(1.04) brightness(1.02);
            }
          }

          .top_account_content_item_info,
          .latest_account_content_item_info {
            .top_account_content_item_info_bot,
            .latest_account_content_item_info_bot {
              #top_account_info_right,
              #latest_account_info_right {
                color: var(--primary-hover, #F97316);
              }
            }
          }

          .top_account_content_item_detail,
          .latest_account_content_item_detail {
            opacity: 1;
            visibility: visible;
            pointer-events: auto;
            transform: translateX(0);
            transition-delay: 0s;
          }
        }

        .top_account_content_item:nth-child(3n):hover,
        .latest_account_content_item:nth-child(3n):hover {
          .top_account_content_item_detail,
          .latest_account_content_item_detail {
            transform: translateX(0);
          }
        }
      }

      .top_account {
        .top_account_content {
          display: grid;
          grid-template-columns: repeat(3, minmax(0, 1fr));
          gap: 14px 13px;

          .top_account_content_item {
            width: 100%;
            box-sizing: border-box;

            .top_account_content_item_info {
              .top_account_content_item_info_top {
                width: 100%;
                height: 68px;
                color: var(--text-main, #111827);
                font-size: 15px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 500;
                line-height: 23px;
                text-align: left;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 3;
                overflow: hidden;
                word-break: break-all;

                span {
                  display: inline-flex;
                  vertical-align: 1px;
                  max-width: 96px;
                  height: 20px;
                  align-items: center;
                  border: 0;
                  border-radius: 4px;
                  padding: 0 8px;
                  margin-right: 6px;
                  background: var(--bg-tag, #F0EDE8);
                  color: var(--text-main, #1A1D24);
                  font-size: 12px;
                  font-weight: 400;
                  line-height: 20px;
                  box-shadow: inset 0 0 0 1px rgba(26, 29, 36, 0.08);
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
              }

              .top_account_content_item_info_bot {
                #top_account_info_right {
                  display: inline-flex;
                  align-items: baseline;
                  justify-content: flex-end;
                  height: 36px;
                  color: var(--primary, #FF7A1A);
                  font-size: 14px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 600;
                  line-height: 36px;
                  white-space: nowrap;
                  letter-spacing: 0;

                  span {
                    margin-left: 1px;
                    font-size: 24px;
                    font-weight: 900;
                    line-height: 36px;
                    letter-spacing: -0.5px;
                  }
                }
              }
            }

            .top_account_content_item_detail {
              display: block;
              height: 326px;
              opacity: 0;
              visibility: hidden;
              pointer-events: none;
              transition: opacity .2s ease, transform .22s ease, visibility 0s linear .22s;

              #top_account_content_item_detail_content {
                height: 250px;
              }
            }

            &:hover {
              .top_account_content_item_detail {
                opacity: 1;
                visibility: visible;
                pointer-events: auto;
                transition-delay: 0s;
              }
            }
          }
        }
      }

      .latest_account {
        .latest_account_content {
          display: grid;
          grid-template-columns: repeat(3, minmax(0, 1fr));
          gap: 14px 13px;

          .latest_account_content_item {
            width: 100%;
            box-sizing: border-box;

            .latest_account_content_item_info {
              .latest_account_content_item_info_top {
                width: 100%;
                height: 68px;
                color: var(--text-main, #111827);
                font-size: 15px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 500;
                line-height: 23px;
                text-align: left;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 3;
                overflow: hidden;
                word-break: break-all;

                span {
                  display: inline-flex;
                  vertical-align: 1px;
                  max-width: 96px;
                  height: 20px;
                  align-items: center;
                  border: 0;
                  border-radius: 4px;
                  padding: 0 8px;
                  margin-right: 6px;
                  background: var(--bg-tag, #F0EDE8);
                  color: var(--text-main, #1A1D24);
                  font-size: 12px;
                  font-weight: 400;
                  line-height: 20px;
                  box-shadow: inset 0 0 0 1px rgba(26, 29, 36, 0.08);
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
              }

              .latest_account_content_item_info_bot {
                #latest_account_info_right {
                  display: inline-flex;
                  align-items: baseline;
                  justify-content: flex-end;
                  height: 36px;
                  color: var(--primary, #FF7A1A);
                  font-size: 14px;
                  font-family: PingFangSC-Regular, PingFang SC;
                  font-weight: 600;
                  line-height: 36px;
                  white-space: nowrap;
                  letter-spacing: 0;

                  span {
                    margin-left: 1px;
                    font-size: 24px;
                    font-weight: 900;
                    line-height: 36px;
                    letter-spacing: -0.5px;
                  }
                }
              }
            }

            .latest_account_content_item_detail {
              display: block;
              height: 326px;
              opacity: 0;
              visibility: hidden;
              pointer-events: none;
              transition: opacity .2s ease, transform .22s ease, visibility 0s linear .22s;

              #latest_account_content_item_detail_content {
                height: 250px;
              }
            }

            &:hover {
              .latest_account_content_item_detail {
                opacity: 1;
                visibility: visible;
                pointer-events: auto;
                transition-delay: 0s;
              }
            }
          }
        }
      }
    }

    // 每日成交 右
    .daily_transaction {
      width: 293px;
      height: 1746px;
      position: relative;
      z-index: 1;
      display: flex;
      flex-direction: column;
      background: var(--bg-card, #FFFFFF);
      border: 1px solid var(--border-soft, #E8E4DE);
      box-shadow: var(--shadow-card, 0 8px 24px rgba(26, 29, 36, 0.08));
      border-radius: 4px;
      box-sizing: border-box;
      overflow: hidden;

      //每日成交顶部
      .daily_transaction_title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        min-height: auto;
        margin: 0;
        padding: 18px 16px 14px;
        border-bottom: 1px solid var(--border-soft, #E8E4DE);
        background: transparent;
        position: relative;
        overflow: visible;

        .daily_transaction_title_logo {
          display: flex;
          align-items: center;
          gap: 9px;
          min-width: 0;
          position: relative;
          z-index: 1;
          padding-bottom: 8px;

          &::after {
            content: '';
            position: absolute;
            left: 43px;
            bottom: 0;
            width: 40px;
            height: 3px;
            background: var(--primary, #FF5A1F);
          }

          .daily_transaction_title_icon {
            flex-shrink: 0;
            width: 34px;
            height: 34px;
            border-radius: 3px;
            background: var(--bg-dark, #1A1D24);
            color: var(--primary, #FF5A1F);
            display: inline-flex;
            align-items: center;
            justify-content: center;
            transform: skewX(-12deg);

            i {
              transform: skewX(12deg);
              font-size: 18px;
            }
          }

          .daily_transaction_title_text {
            flex-shrink: 0;
            display: flex;
            align-items: baseline;
            gap: 6px;
            white-space: nowrap;

            strong {
              font-size: 18px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 900;
              letter-spacing: -0.5px;
              color: var(--text-main, #1A1D24);
              line-height: 1;
              white-space: nowrap;

              span {
                color: var(--primary, #FF5A1F);
              }
            }

            em {
              display: none;
            }
          }
        }

        .daily_transaction_title_more {
          flex-shrink: 0;
          display: inline-flex;
          align-items: center;
          gap: 2px;
          position: relative;
          z-index: 1;
          cursor: pointer;
          font-size: 13px;
          font-family: PingFangSC-Thin, PingFang SC;
          font-weight: 400;
          color: var(--text-muted, #9AA0AC);
          line-height: 20px;
          padding: 0;
          border-radius: 0;
          background: transparent;
          box-shadow: none;
          white-space: nowrap;
          transition: color .2s ease;

          i {
            margin-left: 0;
            font-size: 11px;
            transition: transform .2s ease;
          }
        }

        .daily_transaction_title_more:hover {
          color: var(--primary, #FF5A1F);
          background: transparent;
          box-shadow: none;

          i {
            transform: translateX(2px);
          }
        }
      }

      //每日成交下拉框
      .daily_transaction_filter {
        margin: 26px 20px 0 16px;
        display: flex;
        flex-direction: row;
        align-items: center;

        .daily_transaction_filter_title {
          width: 116px;
          height: 38px;
          line-height: 38px;
          margin-right: 9px;
          background: linear-gradient(270deg, rgba(238, 238, 238, 0) 0%, var(--bg-dark, #1A1D24) 100%);
          border-radius: 4px 0px 0px 4px;

          span:first-of-type {
            width: 8px;
            height: 8px;
            background: #FFFFFF;
            border-radius: 4px;
            margin-left: 12px;
            display: inline-block;
          }

          span:last-of-type {
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            font-size: 16px;
            margin-left: 7px;
          }
        }

        .daily_transaction_filter_select {
          /deep/ .el-select {
            width: 132px;
            height: 38px;
            border-radius: 4px;
            font-size: 14px;
            font-family: PingFangSC-Light, PingFang SC;
            font-weight: 400;
            color: #C0C4CC;
            line-height: 14px;
          }

          /deep/ .el-input.is-focus .el-input__inner {
            border-color: var(--primary, #FF5A1F) !important;
          }

          /deep/ .el-select .el-input__inner:focus {
            border-color: var(--primary, #FF5A1F) !important;
          }

          /deep/ .el-select-dropdown__item.hover {
            background-color: var(--bg-tag, #F0EDE8);
          }

          /deep/ .el-select-dropdown__item.selected {
            color: var(--primary, #FF5A1F);
          }

          /deep/ .el-input__inner {
            font-size: 14px;
            font-family: PingFangSC-Light, PingFang SC;
            font-weight: 400;
            color: #C0C4CC;
          }
        }
      }

      //每日成交内容
      .daily_transaction_content {
        flex: 1;
        min-height: 0;
        height: auto;
        display: flex;
        flex-direction: column;
        flex-wrap: nowrap;
        align-items: center;
        margin: 0 2px 0 0;
        //padding-top: 28px;
        //border-left: 1px solid #596471;
        overflow-x: hidden;
        overflow-y: auto;
        white-space: nowrap;
        padding: 14px 0 14px;
        box-sizing: border-box;

        .daily_transaction_content_item {
          height: 96px;
          box-sizing: border-box;
          border: 1px solid var(--border-soft, #E8E4DE);
          box-shadow: 0 4px 12px rgba(26, 29, 36, 0.06);
          border-radius: 4px;
          margin: 0 auto 12px;
          cursor: pointer;
          padding: 10px;
          display: flex;
          flex-direction: row;
          position: relative;
          flex-shrink: 0;
          overflow: visible;
          background: linear-gradient(180deg, #FFFFFF 0%, var(--bg-section, #F7F5F2) 100%);
          transition: transform .2s ease, border-color .2s ease, box-shadow .2s ease, background .2s ease;

          &::before {
            content: '';
            position: absolute;
            top: 12px;
            bottom: 12px;
            left: 0;
            width: 3px;
            border-radius: 0 4px 4px 0;
            background: transparent;
            transition: background .2s ease, opacity .2s ease;
          }

          &::after {
            content: '';
            position: absolute;
            inset: 0;
            border-radius: 4px;
            box-shadow: inset 0 0 0 0 rgba(26, 29, 36, 0);
            pointer-events: none;
            transition: box-shadow .2s ease;
          }

          &.is-ranked {
            border-color: rgba(26, 29, 36, 0.12);
          }

          &.rank-first {
            background: linear-gradient(180deg, #FFFFFF 0%, #FFF8F0 100%);

            &::before {
              background: var(--primary, #FF7A1A);
              opacity: .7;
            }
          }

          &.rank-second,
          &.rank-third {
            &::before {
              background: var(--brand-blue, #1A1D24);
              opacity: .45;
            }
          }

          .DTCI_top {
            display: none;
          }

          /* 巨型斜体序号（参考原型 .deal .no） */
          .DTCI_no {
            position: absolute;
            right: 10px;
            top: 4px;
            z-index: 1;
            font-style: italic;
            font-weight: 900;
            font-size: 32px;
            line-height: 1;
            color: rgba(26, 29, 36, 0.07);
            pointer-events: none;
          }

          &.rank-first .DTCI_no,
          &.rank-second .DTCI_no,
          &.rank-third .DTCI_no {
            color: rgba(255, 90, 31, 0.22);
          }

          .DTCI_img {
            flex-shrink: 0;
            width: 74px;
            height: 74px;
            margin: 0 12px 0 0;
            border-radius: 4px;
            overflow: hidden;
            background: var(--bg-stage, #0E1116);
            box-shadow: inset 0 0 0 1px rgba(26, 29, 36, 0.08);

            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              display: block;
              transition: transform .24s ease;
            }
          }

          .DTCI_content {
            flex: 1;
            min-width: 0;
            display: flex;
            flex-direction: column;
            justify-content: space-between;

            .DTCI_gameName {
              max-width: 138px;
              font-size: 15px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 500;
              color: var(--text-main, #111827);
              line-height: 20px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .DTCI_orderNum {
              align-self: flex-start;
              max-width: 138px;
              box-sizing: border-box;
              display: inline-flex;
              align-items: baseline;
              padding: 0;
              border-radius: 0;
              background: transparent;
              border: 0;
              font-size: 12px;
              font-family: PingFangSC-Light, PingFang SC;
              font-weight: 400;
              color: var(--text-muted, #9AA0AC);
              line-height: 18px;
              overflow: hidden;

              strong {
                max-width: 52px;
                margin: 0 3px;
                font-size: 15px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 800;
                font-style: normal;
                color: var(--primary, #FF5A1F);
                line-height: 18px;
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }

            .DTCI_date {
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
              font-size: 12px;
              font-family: PingFangSC-Light, PingFang SC;
              font-weight: 300;
              color: var(--text-muted, #9AA0AC);
              line-height: 17px;
              gap: 8px;

              #DTCI_date {
                flex-shrink: 0;
              }

              #DTCI_btn {
                flex-shrink: 0;
                display: inline-flex;
                align-items: center;
                height: 22px;
                padding: 0 6px;
                border-radius: 4px;
                color: var(--brand-blue, #1A1D24);
                font-weight: 400;
                background: transparent;
                transition: color .2s ease, background .2s ease;

                i {
                  margin-left: 1px;
                  font-size: 12px;
                  transition: transform .2s ease;
                }
              }
            }
          }
        }

        .daily_transaction_content_item:hover {
          transform: translateY(-3px);
          border-color: rgba(26, 29, 36, 0.28);
          box-shadow: 0 7px 14px rgba(26, 29, 36, 0.08);
          background: #FFFFFF;

          &::after {
            box-shadow: inset 0 0 0 1px rgba(26, 29, 36, 0.08);
          }

          &::before {
            background: var(--brand-blue, #1A1D24);
            opacity: .9;
          }

          .DTCI_img {
            img {
              transform: scale(1.05);
            }
          }

          .DTCI_content {
            .DTCI_date {
              #DTCI_btn {
                color: var(--primary, #FF7A1A);
                background: var(--primary-soft, #FFF3E7);

                i {
                  transform: translateX(2px);
                }
              }
            }
          }
        }

        .daily_transaction_content_item:last-of-type {
          margin: 0 0 5px 0;
        }

      }

      //每日成交 滚动条
      .daily_transaction_content::-webkit-scrollbar-track{
        //-webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
        //border-radius: 4px;
        //background: rgba(0,0,0,0.1);
      }

      .daily_transaction_content::-webkit-scrollbar  {
        width: 4px;
        height: 4px;
      }

      .daily_transaction_content::-webkit-scrollbar-thumb {
        border-radius: 4px;
        background: rgba(26, 29, 36, 0.16);
      }
    }
  }

  .appDownload{
    display: flex;
    align-items: center;
    justify-content: center;
    position: fixed;
    bottom: 0;
    width: 100vw;
    height: 80px;
    background: rgba(40, 55, 72, 0.6);
    z-index: 999999;
    .btn{
      margin: 0 30px;
      position: absolute;
      right: 0;
      cursor: pointer;
    }
    .ad-conetnt{
      width: 1200px;
      height: 100%;
      position: relative;
      display: flex;
      align-items: center;
      .conetnt{
        height: 60px;
        object-fit: contain;
      }
      .qrcode{
        width: 103px;
        height: 125px;
        position: absolute;
        bottom: 12px;
        right: 0;
      }
    }
  }

}

</style>
<style lang="less">
  .bannerWxDialog{
    position: relative;
    border-radius: 4px;
    .banner-dia-main{
      width: 303px;
      height: 423px;
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: center;
      position: relative;
      .banner-dia-top{
        width: 303px;
        height: 123px;
        background: var(--bg-dark, #1A1D24);
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        font-size: 20px;
        font-family: PingFang SC, PingFang SC-Medium;
        font-weight: 500;
        text-align: center;
        color: #fff;
        padding-top: 25px;
        // box-sizing: border-box;
      }
      .banner-dia-wx{
        position: absolute;
        top: 68px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        >img{
          width: 250px;
          height: 250px;
        }
        .banner-dia-c{
          margin: 13px 0 16px;
          font-size: 14px;
          font-family: PingFang SC, PingFang SC-Regular;
          font-weight: 400;
          img{
            width: 13px;
            height: 16px;
            vertical-align: middle;
          }
        }
        .banner-dia-sys{
          font-size: 20px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          color: #32b440;
          img{
            width: 22px;
            height: 22px;
            vertical-align: middle;
          }
        }
      }
    }
    .banner-dia-close{
      position: absolute;
      width: 30px;
      height: 30px;
      bottom: -40px;
      left: 136.5px;
    }
  }
</style>
